
import React, { useState, useEffect } from "react";

import { authKey, GET_FINANCIAL_YEAR, CREATE_MANUAL_PO, GET_APPROVED_STAKEHOLDERS, UPLOAD_DCUMENT, GET_PLANNING_NUMBER_LIST, GET_GROWER_LAND_LIST, GET_OTHER_PLANNING_NUMBER, GET_PO_TAX_CALCULATION, GET_MAPPED_GROWER_PO_FOR_HIT_MANUAL_PO, CREATE_HIT_MANUAL_PO, GET_MAPPED_PLANNING_NUMBER_LIST, GET_UNRESTRICTED_INVENTORY, FETCH_MAPPED_STAKEHOLDER_BY_TYPE_URN, RB_CB_RATIO, GET_TAX_DETAILS, GET_PO_PREVIEW, GET_DISTANCE_TRAVELLED, GET_AVERAGE_DISTANCE, GET_STOCK_TRANSFER_LIST, CREATE_PLANT_CHIPPING_MANUAL_PO, GET_STAKEHOLDER_BASIC_DETAILS_URN } from '../../common/URLs';
import { toast } from 'react-toastify';
import { loaderService } from "../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../common/localStorageUtils";
import { Typography, Container, Card, CardContent, Box, Grid, TextField, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText, Autocomplete, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Checkbox, Dialog, DialogContent, DialogTitle, Stack } from '@mui/material';
import { ConfirmationPopover } from "../../common/commonPopovers/confirmationPopover";
import { FILE_NAME_VALIDATION_ERROR } from "../../common/constants";
import { allowedFileTypes } from "../../common/constants";
import { fileNameValidation } from "../../common/commonValidations";
import { QuickSearchToolbar } from "../../payment/common/commonFunctions";
import { DataGrid } from "@mui/x-data-grid";
import moment from 'moment';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import { styled } from '@mui/material/styles';
import { Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FileUploadMUI } from "../../common/fileUpload/fileUploadMUI";
import { stakeholderType } from "../../common/spinLoader";
import { handleNumberFieldFocus } from "../../common/commonFunction";
import { AddIcon, PreviewIcon, SubmitIcon, ViewIcon } from "../../common/icons";
import SOCreation from "./sto/stoCreationOfTransferedStock";
import apiClient from "../../axios";
import SpotBiddingPoCreation from "./DemandTransport/spotBiddingPOCreation";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import dayjs from 'dayjs';

export function ManualPoCreation() {
    const navigate = useNavigate();
    const date = new Date();
    const PLANT_STATIC_NAME = "ASSAM BIO ETHANOL PRIVATE LIMITED";
    const [financialYearList, setFinancialYearList] = useState([]);
    const [urnList, setUrnList] = useState([]);
    const [destinationUrnList, setDestinationUrnList] = useState([]);
    const [sourceUrnList, setSourceUrnList] = useState([]);
    const [poStakeholderType, setPoStakeholderType] = useState('');
    const [poStakeholderUrn, setPoStakeholderUrn] = useState('');
    const [createPoResponse, setCreatePoResponse] = useState();
    const [selectedFile, setSelectedFile] = useState();
    const [uploadDocResponse, setUploadDocResponse] = useState();
    const [planningNumberList, setPlanningNumberList] = useState();
    const [hitPlanningNumberList, setHitPlanningNumberList] = useState();
    const [growerLandList, setGrowerLandList] = useState([]);
    const [planningNumber, setPlanningNumber] = useState();
    const [hitPlanningNumber, setHitPlanningNumber] = useState();
    const [otherPlanningNumber, setOtherPlanningNumber] = useState();
    const [poType, setPoType] = useState('');
    const [poMaterialType, setPoMaterialType] = useState('');
    const [inventoryLevel, setInventoryLevel] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [isCheckedBidding, setIsCheckedBidding] = useState(false);
    const [isApiCalled, setIsApiCalled] = useState(false);
    const [stakeHolder, setStakeHolder] = useState();

    const [financialYear, setFinancialYear] = useState('');
    const [monthChange, setMonthChange] = useState();
    const [landName, setLandName] = useState('');
    const [selectedLandId, setSelectedLandId] = useState();
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);

    const [addedGrowerPo, setAddedGrowerPo] = useState([]);
    const [poQuantity, setPoQuantity] = useState();
    const [distanceTravelled, setDistanceTravelled] = useState();

    const [documentsArray, setDocumentsArray] = useState([]);

    const [distinctDestinationUrnValues, setDistinctDestinationUrnValues] = useState([]);
    const [destinationStakeholderUrn, setDestinationStakeholderUrn] = useState('');
    const [destinationStakeholderType, setDestinationStakeholderType] = useState('');

    const [distinctSourceUrnValues, setDistinctSourceUrnValues] = useState([]);
    const [sourceStakeholderUrn, setSourceStakeholderUrn] = useState('');
    const [sourceStakeholderType, setSourceStakeholderType] = useState('');

    const [mappedGrowerPoList, setMappedGrowerPoList] = useState();
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [shortCloseQty, setShortCloseQty] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const [shortCloseQtyValidation, setShortCloseQtyValidation] = useState();
    const [isShortClosePreviousPO, setIsShortClosePreviousPO] = useState(false);
    const [rbRbRation, setRbRbRation] = useState();
    const [getTaxDetails, setGetTaxDetails] = useState('');
    const [previewDetails, setPreviewDetails] = useState();
    const [selectedStakeholder, setSelectedStakeholder] = useState(null);
    const [sourceStakeholderDetails, setSourceStakeholderDetails] = useState(null);
    const [destinationStakeholderDetails, setDestinationStakeholderDetails] = useState(null);
    const [poValidityDate, setPoValidityDate] = useState(null);
    const [poSubject, setPoSubject] = useState('');

    const [open, setOpen] = React.useState(false);

    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);

    const [confirmOpen2, setConfirmOpen2] = useState(false);
    const handleConfirmOpen2 = () => setConfirmOpen2(true);
    const handleConfirmClose2 = () => setConfirmOpen2(false);

    const [confirmOpen3, setConfirmOpen3] = useState(false);
    const handleConfirmOpen3 = () => setConfirmOpen3(true);
    const handleConfirmClose3 = () => setConfirmOpen3(false);

    const [manualPoDetails, setManualPoDetails] = useState({
        "poDescription": "",
        "serviceStakeholderType": "",
    });

    const [errorMessage, setErrorMessage] = useState({
        "poDescriptionError": "",
        "poMaterialTypeError": "",
        "poTypeError": "",
        "serviceStakeholderTypeError": "",
        "poStakeholderTypeError": "",
        "poStakeholderUrnError": "",
        "poQuantityError": '',
        "financialYearError": "",
        "monthError": "",
        "planningNumberError": "",
        "hitplanningNumberError": "",
        "landNameError": "",
        "isOtherPlanningNumber": "",
        "isShortCloseError": "",
        "searchUrnError": "",
        "totalShortCloseQtyError": "",
        "noPoSelectedError": "",
        "poShortCloseQuantityError": "",
        "growerPoDuplicateError": "",
        "destinationStakeholderUrnError": "",
        "destinationStakeholderTypeError": "",
        "sourceStakeholderUrnError": "",
        "sourceStakeholderTypeError": "",
        "distanceTravelledError": "",
        "poValidityDateError": '',
        "poSubjectError": ''
    });

    useEffect(() => {
        getFinancialYearApi();
    }, []);

    const getFinancialYearApi = () => {
        loaderService.showLoader();
        apiClient.post(GET_FINANCIAL_YEAR,
            null,
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setFinancialYearList(response.data?.financialYearLst);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }


    const getPlanningNumberList = (financialYear, month) => {
        loaderService.showLoader();
        apiClient.post(GET_PLANNING_NUMBER_LIST,
            {
                "financialYear": financialYear,
                "month": month
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setPlanningNumberList(response.data.planningNumberList);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getOtherPlanningNumber = () => {
        loaderService.showLoader();
        apiClient.post(GET_OTHER_PLANNING_NUMBER,
            {
                "financialYear": financialYear,
                "month": monthChange
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setOtherPlanningNumber(response.data.otherPlanningNumber);
                getAverageDistance(sourceStakeholderUrn, destinationStakeholderUrn, response.data.otherPlanningNumber)
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const sortedYears = financialYearList?.sort((a, b) => {
        const yearA = parseInt(a.split('-')[0]);
        const yearB = parseInt(b.split('-')[0]);
        return yearA - yearB;
    });

    useEffect(() => {
        if (poStakeholderType) {
            onStakeholderTypeChange();
        }

    }, [poStakeholderType]);

    const onStakeholderTypeChange = () => {
        loaderService.showLoader();
        apiClient.post(GET_APPROVED_STAKEHOLDERS,
            {
                "type": poStakeholderType
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setUrnList(response.data.stakeHolders);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getGrowerLandList = (searchUrn) => {
        loaderService.showLoader();
        apiClient.post(GET_GROWER_LAND_LIST,
            {
                "growerUrn": searchUrn ? searchUrn : ''
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setGrowerLandList(response.data.growerLandNameList);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    useEffect(() => {
        if (isShortClosePreviousPO === true && financialYear && monthChange && searchTerm) {
            getGrowerHitMappedPO();
        }
    }, [isShortClosePreviousPO, financialYear, monthChange, searchTerm]);

    const getGrowerHitMappedPO = (urn) => {
        loaderService.showLoader();
        apiClient.post(GET_MAPPED_GROWER_PO_FOR_HIT_MANUAL_PO,
            {
                "financialYear": financialYear,
                "planningMonth": monthChange,
                "stakeholderUrn": urn ? urn : searchTerm
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setMappedGrowerPoList(response.data.poDetailsList);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const handleChange = (e) => {
        setManualPoDetails({ ...manualPoDetails, [e.target.name]: e.target.value });
        if (e.target.name === "poDescription") {
            setErrorMessage({ ...errorMessage, poDescriptionError: "" });
        }
        if (e.target.name === "serviceStakeholderType") {
            setErrorMessage({ ...errorMessage, serviceStakeholderTypeError: "" });
        }
    };

    const onFinancialYearChange = (e) => {
        setFinancialYear(e.target.value);
        setErrorMessage({ ...errorMessage, financialYearError: "" });
        if (poStakeholderType === "HIT") {
            getHITPlanningNumberList(e.target.value, monthChange, searchTerm, destinationStakeholderType, destinationStakeholderUrn);
        }
        else {
            getPlanningNumberList(financialYear, e.target.value);
        }
    }

    const onMonthChange = (e) => {
        setMonthChange(e.target.value);
        setErrorMessage({ ...errorMessage, monthError: "" });
        if (poStakeholderType === "HIT") {
            getHITPlanningNumberList(financialYear, e.target.value, searchTerm, destinationStakeholderType, destinationStakeholderUrn);
        }
        else {
            getPlanningNumberList(financialYear, e.target.value);
        }
    }

    const onPlanningNumberChange = (e) => {
        setPlanningNumber(e.target.value);
        e.target.value !== "Other" && getAverageDistance(sourceStakeholderUrn, destinationStakeholderUrn, e.target.value)
        setErrorMessage({ ...errorMessage, planningNumberError: "" });
        if (e.target.value === "Other") {
            getOtherPlanningNumber()
        }
    }

    const onHitPlanningNumberChange = (e) => {
        setHitPlanningNumber(e.target.value);
        e.target.value !== "Other" && getAverageDistance(sourceStakeholderUrn, destinationStakeholderUrn, e.target.value)
        setErrorMessage({ ...errorMessage, hitplanningNumberError: "" });
        if (e.target.value === "Other") {
            getOtherPlanningNumber()
        }
    }

    const onTypeChange = (e) => {
        setPoStakeholderType(e.target.value);
        if (e.target.value === "HIT") {
            getHITPlanningNumberList(financialYear, monthChange, searchTerm, destinationStakeholderType, destinationStakeholderUrn);
        }
        setErrorMessage({ ...errorMessage, poStakeholderTypeError: "" });
        setPlanningNumber();
        setHitPlanningNumber();
        setPoMaterialType('');
        setPoType('');
        setManualPoDetails({
            "poDescription": "",
            "serviceStakeholderType": "",
        })
        setSearchTerm('');
        setSelectedStakeholder(null)
        setDestinationStakeholderType('');
        setDestinationStakeholderUrn('');
        setSourceStakeholderType('');
        setSourceStakeholderUrn('');
        setSourceStakeholderDetails(null);
        setDestinationStakeholderDetails(null);
        setPoQuantity('');
        setGetTaxDetails('');
        setInventoryLevel('');
        setDistanceTravelled();            //for initial values                     
    }

    const onPoMaterialTypeChange = (e) => {
        setPoMaterialType(e.target.value);
        setErrorMessage({ ...errorMessage, poMaterialTypeError: "" });

    }
    const onPoTypeChange = (e) => {
        setPoType(e.target.value);
        setSearchTerm('');
        setDestinationStakeholderType('');
        setDestinationStakeholderUrn('');
        setDistanceTravelled();
        setSourceStakeholderType('');
        setSourceStakeholderUrn('');
        setErrorMessage({ ...errorMessage, poTypeError: "" });
        setManualPoDetails({
            "poDescription": "",
            "serviceStakeholderType": "",
        })
        setGetTaxDetails('');
        setInventoryLevel('');
    }


    const onLandNameChange = (e) => {
        setLandName(growerLandList.find(item => item.landId === e.target.value)?.landName);
        setErrorMessage({ ...errorMessage, landNameError: "" });
        setSelectedLandId(e.target.value);
    }


    // const onConfirmSubmit = (e) => {
    //     handleLogModalClose();
    //     createManualPo(addedGrowerPo);
    // }



    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await createManualPo(addedGrowerPo);
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogModalOpen(false);
            setIsApiCalled(false);
        }
    };

    const onSubmitButtonClick = (e) => {
        handleLogModalOpen();
    }

    const onSubmit = (e) => {
        setErrorMessage({ ...errorMessage, growerPoDuplicateError: "" })
        if (!financialYear) {
            setErrorMessage({ ...errorMessage, financialYearError: "Please Select Financial Year" })
        }
        else if (!monthChange) {
            setErrorMessage({ ...errorMessage, monthError: "Please Select Month" })
        }
        else if (!planningNumber) {
            setErrorMessage({ ...errorMessage, planningNumberError: "Please Select Planning Number" })
        }
        else if (!poStakeholderType) {
            setErrorMessage({ ...errorMessage, poStakeholderTypeError: "Please Select Stakeholder Type" })
        }
        // else if (!poStakeholderUrn) {
        //     setErrorMessage({ ...errorMessage, poStakeholderUrnError: "Please Select Stakeholder URN" })
        // }
        else if (!poType) {
            setErrorMessage({ ...errorMessage, poTypeError: "Please Enter Material Type" })
        }
        else if (!poMaterialType) {
            setErrorMessage({ ...errorMessage, poMaterialTypeError: "Please Enter Material Type" })
        }
        else {
            onSubmitButtonClick();
        }

    }

    const onConfirmHitSubmit = (e) => {
        handleConfirmClose2();
        // onHitPOCreationSbmit(e);
        createManualPoForHIT();
    }

    const onHitSubmitButtonClick = (e) => {
        handleConfirmOpen2();
    }

    // const onHitPOCreationSbmit = (e) => {
    //     e.preventDefault();
    //     createManualPoForHIT();
    // }

    const onHitSubmit = (e) => {
        let error = false;
        selectedRows?.forEach(item => {
            if (!item.poShortCloseQuantity) {
                error = true;
            }
        })

        if (!financialYear) {
            setErrorMessage({ ...errorMessage, financialYearError: "Please Select Financial Year" })
        }
        else if (!monthChange) {
            setErrorMessage({ ...errorMessage, monthError: "Please Select Month" })
        }
        else if (!poStakeholderType) {
            setErrorMessage({ ...errorMessage, poStakeholderTypeError: "Please Select Stakeholder Type" })
        }
        else if (poStakeholderType !== "HIT" && !planningNumber) {
            setErrorMessage({ ...errorMessage, planningNumberError: "Please Select Planning Number" })
        }
        else if (!poType) {
            setErrorMessage({ ...errorMessage, poTypeError: "Please Select PO Type" })
        }
        else if (poType === "SO" && !manualPoDetails?.serviceStakeholderType) {
            setErrorMessage({ ...errorMessage, serviceStakeholderTypeError: "Please Select SO Type" })
        }
        else if (poType === "SCO" && !manualPoDetails?.serviceStakeholderType) {
            setErrorMessage({ ...errorMessage, serviceStakeholderTypeError: "Please Select SCO Type" })
        }
        else if (!poMaterialType) {
            setErrorMessage({ ...errorMessage, poMaterialTypeError: "Please Select Material Type" })
        }
        // else if (isShortClosePreviousPO === "") {
        //     setErrorMessage({ ...errorMessage, isShortCloseError: "Please Select" })
        // }
        else if (!searchTerm) {
            setErrorMessage({ ...errorMessage, searchUrnError: "Please Select URN" })
        }
        // else if (!(poStakeholderType === "LLE" && poType === "SO" && manualPoDetails?.serviceStakeholderType === "Chipping")) {
        //     if (!destinationStakeholderType) {
        //         setErrorMessage({ ...errorMessage, destinationStakeholderTypeError: "Please select Destination Type" })
        //     }
        //    else if (!destinationStakeholderUrn) {
        //         setErrorMessage({ ...errorMessage, destinationStakeholderUrnError: "Please select Destination URN" })
        //     }
        // }
        else if (poStakeholderType === "Transporter" && !sourceStakeholderType) {
            setErrorMessage({ ...errorMessage, sourceStakeholderTypeError: "Please select Source Type" })
        }
        else if (poStakeholderType === "Transporter" && !sourceStakeholderUrn) {
            setErrorMessage({ ...errorMessage, sourceStakeholderUrnError: "Please select Source URN" })
        }
        else if ((!(poStakeholderType === "LLE" && poType === "SCO" && manualPoDetails?.serviceStakeholderType === "Chipping")) && !destinationStakeholderType) {
            setErrorMessage({ ...errorMessage, destinationStakeholderTypeError: "Please select Destination Type" })
        }
        else if ((!(poStakeholderType === "LLE" && poType === "SCO" && manualPoDetails?.serviceStakeholderType === "Chipping")) && !destinationStakeholderUrn) {
            setErrorMessage({ ...errorMessage, destinationStakeholderUrnError: "Please select Destination URN" })
        }
        else if (poStakeholderType === "HIT" && !planningNumber) {
            setErrorMessage({ ...errorMessage, planningNumberError: "Please Select Planning Number" })
        }
        else if (poStakeholderType === "HIT" && isShortClosePreviousPO === false && shortCloseQty <= 0) {
            setErrorMessage({ ...errorMessage, totalShortCloseQtyError: "Quantity should be more than 0" })
        }
        // else if (isShortClosePreviousPO === true && selectedRows?.length === 0) {
        //     setErrorMessage({ ...errorMessage, noPoSelectedError: "Please select atleast one PO and enter short close quantity" })
        // }
        else if (!(poStakeholderType === "HIT") && !poQuantity) {
            setErrorMessage({ ...errorMessage, poQuantityError: "PO Quantity should be more than 0" })
        }
        else if ((poStakeholderType === "Transporter" || (poStakeholderType === "HIT" && manualPoDetails.serviceStakeholderType === "Transporter")) && !distanceTravelled) {
            setErrorMessage({ ...errorMessage, distanceTravelledError: "Distance Travelled should be more than 0" })
        }
        else if (error) {
            setErrorMessage({ ...errorMessage, poShortCloseQuantityError: "Short Close Quantity is required for selected PO." })
        }
        else if (!poValidityDate) {
            setErrorMessage({ ...errorMessage, poValidityDateError: "PO Validity Date is required" });
        }
        // else if (!manualPoDetails?.poDescription) {
        //     setErrorMessage({ ...errorMessage, poDescriptionError: "Please Write Description" })
        // }
        else {
            onHitSubmitButtonClick();
        }

    }

    const getDistanceTravelled = (sourceUrn, destinationUrn) => {
        loaderService.showLoader();
        apiClient
            .post(
                GET_DISTANCE_TRAVELLED,
                {
                    "sourceURN": sourceUrn,
                    "sourceType": sourceStakeholderType,
                    "growerLandId": poStakeholderType === "Grower" ? selectedLandId : null,
                    "destinationURN": destinationUrn,
                    "destinationType": destinationStakeholderType,
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                        AuthKey: authKey,
                    }
                }
            )
            .then((response) => {
                setDistanceTravelled(response.data.distanceInKM)
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log("apiClientERROR", error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const getAverageDistance = (sourceUrn, destinationUrn, planningNo) => {
        loaderService.showLoader();
        apiClient
            .post(
                GET_AVERAGE_DISTANCE,
                {
                    "hitURN": searchTerm,
                    "financialYear": financialYear,
                    "month": monthChange,
                    "planningNumber": planningNo,
                    "destinationStakeholderType": destinationStakeholderType,
                    "destinationStakeholderUrn": destinationUrn
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                        AuthKey: authKey,
                    }
                }
            )
            .then((response) => {
                loaderService.hideLoader();
                setDistanceTravelled(response.data.distanceInKM)
            })
            .catch(function (error) {
                console.log("apiClientERROR", error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const addGrowerForPoCreation = () => {
        loaderService.showLoader();
        apiClient
            .post(
                GET_PO_TAX_CALCULATION,
                {
                    // "id": uuid,
                    "stakeholderType": poStakeholderType,
                    "stakeholderUrn": searchTerm,
                    "landId": selectedLandId,
                    "landName": landName,
                    "poQuantity": poQuantity,
                    "destinationStakeholderType": destinationStakeholderType,
                    "destinationStakeholderUrn": destinationStakeholderUrn,
                    "financialYear": financialYear,
                    "month": monthChange,
                    "planningNumber": planningNumber === "Other" ? otherPlanningNumber : planningNumber,
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                }
            )
            .then((response) => {
                if (response.data.isSuccess === false) {
                    toast.error(response.data.message)
                }
                else setAddedGrowerPo([...addedGrowerPo, response.data.poTax]);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log("apiClientERROR", error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };


    const createManualPo = (addedGrowerPo) => {
        loaderService.showLoader();
        apiClient
            .post(
                CREATE_MANUAL_PO,
                {
                    "financialYear": financialYear,
                    "month": monthChange,
                    "planningNumber": planningNumber === "Other" ? otherPlanningNumber : planningNumber,
                    "isOtherPlanningNumber": planningNumber === "Other" ? true : false,
                    "poSubject": poSubject,
                    "poValidityDate": poValidityDate,
                    "poDescription": payloadWithNewline,
                    "poMaterialType": poMaterialType,
                    "poType": poType,
                    "serviceStakeholderType": manualPoDetails?.serviceStakeholderType,
                    "materialCode": poMaterialType === "rawbamboo" ? "RB" : poMaterialType === "chipbamboo" ? "CB" : "Service",
                    "supportingDocumentId": uploadDocResponse?.blobResponse?.blobFileName,
                    "supportingDocumentName": uploadDocResponse?.blobResponse?.fileName,
                    "containerName": "pit",
                    "manualPOCreationList": addedGrowerPo

                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                }
            )
            .then((response) => {
                setCreatePoResponse(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log("apiClientERROR", error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };


    useEffect(() => {
        if (createPoResponse) {
            if (createPoResponse.isSuccess === true) {
                toast.success(createPoResponse?.message)
                if (poType === "PO") {
                    navigate('/poList')
                }
                else if (poType === "SO") {
                    navigate('/soList')
                }
                else if (poType === "SCO") {
                    navigate('/scoList')
                }
                else navigate('/stoList')
            }
            else {
                toast.error(createPoResponse?.message ? createPoResponse?.message : "Error")
            }
        }
    }, [createPoResponse]);

    const payloadWithNewline = manualPoDetails?.poDescription?.replace(/\n/g, "<br />");


    const onConfirmPlantSubmit = (e) => {
        handleConfirmClose3();
        // onHitPOCreationSbmit(e);
        createManualPoForPlantChipping();
    }

    const onPlantSubmitButtonClick = (e) => {
        handleConfirmOpen3();
    }

    // const onHitPOCreationSbmit = (e) => {
    //     e.preventDefault();
    //     createManualPoForHIT();
    // }

    const onPlantSubmit = (e) => {
        e.preventDefault();
        if (!financialYear) {
            setErrorMessage({ ...errorMessage, financialYearError: "Please Select Financial Year" })
        }
        else if (!monthChange) {
            setErrorMessage({ ...errorMessage, monthError: "Please Select Month" })
        }
        else if (!poStakeholderType) {
            setErrorMessage({ ...errorMessage, poStakeholderTypeError: "Please Select Stakeholder Type" })
        }
        else if (!poType) {
            setErrorMessage({ ...errorMessage, poTypeError: "Please Select PO Type" })
        }
        else if (poType === "SCO" && !manualPoDetails?.serviceStakeholderType) {
            setErrorMessage({ ...errorMessage, serviceStakeholderTypeError: "Please Select SCO Type" })
        }
        else if (!poMaterialType) {
            setErrorMessage({ ...errorMessage, poMaterialTypeError: "Please Select Material Type" })
        }
        else if (!searchTerm) {
            setErrorMessage({ ...errorMessage, searchUrnError: "Please Select URN" })
        }
        else if (!poQuantity) {
            setErrorMessage({ ...errorMessage, poQuantityError: "PO Quantity should be more than 0" })
        }
        else {
            onPlantSubmitButtonClick();
        }
    }

    const createManualPoForHIT = () => {
        loaderService.showLoader();
        apiClient
            .post(
                CREATE_HIT_MANUAL_PO,
                {
                    "financialYear": financialYear,
                    "month": monthChange,
                    "planningNumber": planningNumber === "Other" ? otherPlanningNumber : planningNumber,
                    "isOtherPlanningNumber": planningNumber === "Other" ? true : false,
                    "poStakeholderType": poStakeholderType,
                    "poStakeholderUrn": searchTerm,
                    "destinationStakeholderType": destinationStakeholderType,
                    "destinationStakeholderUrn": destinationStakeholderUrn,
                    "sourceStakeholderType": sourceStakeholderType,
                    "sourceStakeholderUrn": sourceStakeholderUrn,
                    "poSubject": poSubject,
                    "poValidityDate": poValidityDate,
                    "poDescription": payloadWithNewline,
                    "poMaterialType": poMaterialType,
                    "poType": poType,
                    "poQuantity": poStakeholderType === "HIT" ? shortCloseQty : poQuantity,
                    "serviceStakeholderType": manualPoDetails?.serviceStakeholderType,
                    "materialCode": "",
                    "supportingDocumentId": documentsArray?.find((item) => item.documentType === "poSupportingDoc")?.documentBlobName,
                    "supportingDocumentName": documentsArray?.find((item) => item.documentType === "poSupportingDoc")?.documentName,
                    "containerName": "pit",
                    "isShortClosePreviousPO": isShortClosePreviousPO,
                    "totalShortCloseQuantity": isShortClosePreviousPO === false ? shortCloseQty : totalQuantity,
                    "poListForShortCLose": selectedRows,
                    "distanceTravelled": distanceTravelled,
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                }
            )
            .then((response) => {
                setCreatePoResponse(response.data);

                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log("apiClientERROR", error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const createManualPoForPlantChipping = () => {
        loaderService.showLoader();
        apiClient
            .post(
                CREATE_PLANT_CHIPPING_MANUAL_PO,
                {
                    "financialYear": financialYear,
                    "month": monthChange,
                    "planningNumber": planningNumber === "Other" ? otherPlanningNumber : planningNumber,
                    "isOtherPlanningNumber": planningNumber === "Other" ? true : false,
                    "poStakeholderType": poStakeholderType,
                    "poStakeholderUrn": searchTerm,
                    "poDescription": payloadWithNewline,
                    "poMaterialType": poMaterialType,
                    "poType": poType,
                    "poQuantity": poQuantity,
                    "serviceStakeholderType": manualPoDetails?.serviceStakeholderType,
                    "materialCode": "",
                    "supportingDocumentId": documentsArray?.find((item) => item.documentType === "poSupportingDoc")?.documentBlobName,
                    "supportingDocumentName": documentsArray?.find((item) => item.documentType === "poSupportingDoc")?.documentName,
                    "containerName": "pit"
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                }
            )
            .then((response) => {
                setCreatePoResponse(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log("apiClientERROR", error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };


    useEffect(() => {
        if (selectedFile) {
            getUploadFileDetails();
        }
    }, [selectedFile]);

    function getUploadFileDetails() {
        loaderService.showLoader();
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("fileName", selectedFile.name);
        formData.append("containerName", "pit");
        apiClient
            .post(UPLOAD_DCUMENT, formData, {
                headers: {
                    AuthKey: authKey,
                },
            })
            .then((response) => {
                setUploadDocResponse(response.data);
                loaderService.hideLoader();
            })

            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const uploadNocDoc = (e, type) => {
        if (allowedFileTypes.indexOf(e.target.files[0].type) < 0) {
            return;
        }
        if (e.target.files[0].name.split('.').length > 2) {
            setErrorMessage({
                ...errorMessage,
                fileError: "Double extension file detected",
            });
            return;
        }
        if (e.target.files[0].size >= 5000000) {
            setErrorMessage({
                ...errorMessage,
                fileError: "The file should be less than 5MB",
            });
        }
        else if (fileNameValidation(e.target.files[0].name)) {
            setErrorMessage({
                ...errorMessage,
                fileError: FILE_NAME_VALIDATION_ERROR,
            });
        } else {
            setSelectedFile(e.target.files[0]);
            // setPickupUpdatedDetails({ ...pickupUpdatedDetails, nocFileId: nocUploadDOc ? nocUploadDOc?.blobResponse?.blobFileName : RBfileDownload?.nocFileId, nocFileName: nocUploadDOc ? nocUploadDOc?.blobResponse?.fileName : RBfileDownload?.nocFileName, containerName: "pit" })
            setErrorMessage({ ...errorMessage, fileError: " " });
        }
    };

    useEffect(() => {
        if (uploadDocResponse) {
            if (uploadDocResponse.isSuccess === true) {
                toast.success(uploadDocResponse?.message)
            }
            else {
                toast.error(uploadDocResponse?.message ? uploadDocResponse?.message : "Error")
            }
        }
    }, [uploadDocResponse]);

    const options = [
        { value: 'PO', label: 'PO' },
        { value: 'SO', label: 'SO' },
        { value: 'SCO', label: 'SCO' },
        // { value: 'STO', label: 'STO' },
    ];

    const filteredOptions = () => {
        switch (poStakeholderType) {
            case 'Grower':
                return options.filter(option => option.value === 'PO');
            case 'LLE':
                return options.filter(option => option.value === 'SCO');
            case 'Plant':
                return options.filter(option => option.value === 'SCO');
            case 'HIT':
                return options.filter(option => option.value === 'SO');
            case 'Transporter':
                return options.filter(option => option.value === 'SO');
            default:
                return [];
        }
    };

    const materialTypeOptions = [
        { value: 'rawbamboo', label: 'Raw Bamboo' },
        { value: 'chipbamboo', label: 'Chip Bamboo' },
    ];

    const filteredMaterialTypeOptions = () => {
        switch (poStakeholderType) {
            case 'Grower':
                return materialTypeOptions.filter(option => option.value === 'rawbamboo');
            case 'LLE':
                // if (poType === "SCO" && manualPoDetails?.serviceStakeholderType === "Chipping") {
                return materialTypeOptions.filter(option => option.value === 'chipbamboo');
            // }
            // else return materialTypeOptions.filter(option => option.value === 'rawbamboo' || option.value === 'chipbamboo');
            case 'Plant':
                return materialTypeOptions.filter(option => option.value === 'chipbamboo');;
            case 'HIT':
                return materialTypeOptions.filter(option => option.value === 'rawbamboo');
            case 'Transporter':
                return materialTypeOptions;
            default:
                return [];
        }
    };

    const soTypeOptions = [
        { value: 'Harvester', label: 'Harvester' },
        { value: 'Transporter', label: 'Transporter' },
        { value: 'Chipping', label: 'Chipping' },
    ];

    const filteredSoTypeOptions = () => {
        switch (poType) {
            case 'SO':
                if (poStakeholderType === "LLE") {
                    return soTypeOptions.filter(option => option.value === 'Chipping');
                }
                else if (poStakeholderType === "Transporter") {
                    return soTypeOptions.filter(option => option.value === 'Transporter');
                }
                else if (poStakeholderType === "HIT") {
                    return soTypeOptions.filter(option => option.value === 'Harvester' || option.value === 'Transporter');
                }
            default:
                return [];
        }
    };

    const urns = poStakeholderType === "Plant" ? ["ABEPL"] : urnList;

    const handleSearch = (query) => {
        const q = String(query).toLowerCase();

        const results = urns?.filter(item => {
            const urn = String(item.urn || "");
            const name = String(item.name || "");
            return urn.toLowerCase().includes(q) || name.toLowerCase().includes(q);
        }) || [];

        setSearchResults(results);
    };

    const handleClear = () => {
        setSearchTerm('');
        setSearchResults([]);
    };


    const handleAddButtonClick = () => {
        if (!poValidityDate) {
            setErrorMessage({ ...errorMessage, poValidityDateError: "PO Validity Date is required" })
        }
        else if (!searchTerm) {
            setErrorMessage({ ...errorMessage, searchUrnError: "Please Select URN" })
        }
        else if (!landName) {
            setErrorMessage({ ...errorMessage, landNameError: "Please Select Land" });
        }
        else if (!poQuantity) {
            setErrorMessage({ ...errorMessage, poQuantityError: "Please Enter PO Quantity" })
        }
        else if (poQuantity <= 0) {
            setErrorMessage({ ...errorMessage, poQuantityError: "PO Quantity should be more than 0" })
        }
        else if (!destinationStakeholderType) {
            setErrorMessage({ ...errorMessage, destinationStakeholderTypeError: "Please Select Destination Stakeholder Type" })
        }
        else if (!destinationStakeholderUrn) {
            setErrorMessage({ ...errorMessage, destinationStakeholderUrnError: "Please Select Destination Stakeholder URN" })
        }
        else {
            const isDuplicate = addedGrowerPo?.find(
                (row) =>
                    row.landId === selectedLandId

            );
            if (!isDuplicate) {
                addGrowerForPoCreation();
                setAddedGrowerPo([...addedGrowerPo]);
                setSearchTerm('');
                setGrowerLandList([]);
                setPoQuantity('');
                setLandName("");
                setDestinationStakeholderType('')
                setDestinationUrnList([])
                setDestinationStakeholderUrn('')
                setSourceStakeholderType('')
                setSourceUrnList([])
                setSourceStakeholderUrn('')
                setSelectedStakeholder(null);
                setDestinationStakeholderDetails(null);
                setErrorMessage({ ...errorMessage, growerPoDuplicateError: "" })
                setDistanceTravelled();
            } else {
                // setErrorMessage({ ...errorMessage, growerPoDuplicateError: "Grower already added! Please remove or select different Grower!" })
                toast.error("Grower already added! Please remove or select different Grower!")
            }
        }
    };

    const handleRemoveButtonClick = (landIdtoremove) => {
        const updatedData = [...addedGrowerPo];
        setAddedGrowerPo(updatedData.filter((row) => row.landId !== landIdtoremove));
    };


    const columns2 = [
        { field: 'stakeholderUrn', headerName: 'URN', width: 130 },
        { field: 'landName', headerName: 'Land Name', width: 130 },
        { field: 'destinationStakeholderType', headerName: 'Destination Type', width: 130 },
        { field: 'destinationStakeholderUrn', headerName: 'Destination URN', width: 130 },
        { field: 'poQuantity', headerName: 'Quantity (MT)', width: 100 },
        { field: 'rate', headerName: 'Rate', width: 100 },
        { field: 'amount', headerName: 'Amount (INR)', width: 100 },
        { field: 'cgst', headerName: 'CGST', width: 100 },
        { field: 'sgst', headerName: 'SGST', width: 100 },
        { field: 'totalAmount', headerName: 'Total', width: 100 },
        {
            field: 'action',
            headerName: 'Action', width: 100,
            renderCell: (params) => (

                <Button onClick={() => handleRemoveButtonClick(params.row.landId)} variant="contained" color="primary">
                    Remove
                </Button>

            ),

        },
        {
            field: "Preview",
            renderCell: (params) => {
                return (
                    <>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => getPoPreview(params.row)}>Preview</Button>
                    </>
                )
            }
        },

    ];

    const handleClickOpen = (cellValues) => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const radioChange = (e, value) => {
        setIsShortClosePreviousPO(value);
        if (value === true || value === false) {
            setErrorMessage({ ...errorMessage, isShortCloseError: "" });
        }
    };

    useEffect(() => { // Update total quantity whenever mappedGrowerList changes 
        const selectedRows = mappedGrowerPoList?.filter((row) => row.isChecked);
        const total = selectedRows?.reduce((acc, row) => acc + row.poShortCloseQuantity, 0);
        setTotalQuantity(total);
        setSelectedRows(selectedRows);
        sendSelectedRowsData(selectedRows);
    }, [mappedGrowerPoList]);

    const onShortCloseQtyChange = (e) => {
        setShortCloseQty(e.target.value.slice(0, 10));
        setErrorMessage({ ...errorMessage, totalShortCloseQtyError: "" });
    }

    const sendSelectedRowsData = (selectedRows) => {
        // Validate shortCloseQuantity before sending data
        const hasValidationError = selectedRows?.some((row) => {
            if (row.isChecked && row.poShortCloseQuantity === 0) {
                setMappedGrowerPoList((prevRows) =>
                    prevRows.map((prevRow) => (prevRow.id === row.id ? { ...prevRow, error: 'Short Close Quantity is required.' } : prevRow))
                );
                return true;
            }
            return false;
        });
        // setShortCloseQtyValidation(hasValidationError);
        if (!hasValidationError) {
            // Prepare data in the desired format
            const formattedData = selectedRows?.map((row) => ({
                PoNumber: row.poNumber,
                poQuantity: row.poQuantity,
                poBalanceQuantity: row.poBalanceQuantity,
                planningNumber: row.planningNumber,
                poShortCloseQuantity: row.poShortCloseQuantity,
            }));

            setSelectedRows(formattedData);
        }
    };

    const handleCheckboxChange = (id) => {
        setMappedGrowerPoList((prevRows) =>
            prevRows?.map((row) => {
                if (row.id === id) {
                    const updatedRow = { ...row, isChecked: !row.isChecked };
                    if (!updatedRow.isChecked) {
                        // If unselected, reset quantity to 0
                        updatedRow.totalShortCloseQuantity = 0;
                        updatedRow.poShortCloseQuantity = 0;
                    }
                    return updatedRow;
                }
                return row;
            })
        );
        setErrorMessage({ ...errorMessage, noPoSelectedError: "" });
    };

    const handleQuantityChange = (id, poShortCloseQuantity) => {
        setMappedGrowerPoList((prevRows) =>
            prevRows.map((row) =>
                row.id === id ? { ...row, poShortCloseQuantity: parseInt(poShortCloseQuantity, 10) || 0 } : row
            )
        );
        setErrorMessage({ ...errorMessage, poShortCloseQuantityError: "" });
    };

    const onPoQuantityChange = (e) => {
        setPoQuantity(e.target.value.slice(0, 10))
        setErrorMessage({ ...errorMessage, poQuantityError: "" });
    }

    const onDistanceTravelledChange = (e) => {
        e.preventDefault();
        setDistanceTravelled(e.target.value.slice(0, 10))
        setErrorMessage({ ...errorMessage, distanceTravelledError: "" });
    }

    const getHITPlanningNumberList = (Year, month, selectedUrn, destinationType, destinationUrn) => {
        loaderService.showLoader();
        apiClient.post(GET_MAPPED_PLANNING_NUMBER_LIST,
            {
                "stakeHolderUrn": selectedUrn,
                "stakeHolderType": "HIT",
                "mappedStakeHolderType": "Grower",
                "financialYear": Year ? Year : financialYear,
                "month": month ? month : monthChange,
                "destinationStakeHolderType": destinationType ? destinationType : destinationStakeholderType,
                "destinationStakeHolderUrn": destinationUrn ? destinationUrn : destinationStakeholderUrn
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setHitPlanningNumberList(response.data.planningNumberList);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getUnrestrictedInventory = (selectedUrn) => {
        loaderService.showLoader();
        apiClient.post(GET_UNRESTRICTED_INVENTORY,
            {
                "stakeHolderUrn": selectedUrn,
                "stakeHolderType": poStakeholderType
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setInventoryLevel(response.data.inventoryMovementSum);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const columns = [
        {
            field: 'select',
            headerName: 'Select',
            width: 120,
            renderCell: (params) => (
                <Checkbox
                    checked={params.row.isChecked || false} // Set default value to false
                    onChange={() => handleCheckboxChange(params.row.id)}
                />
            ),
        },
        { field: 'poNumber', headerName: 'PO', flex: 1 },
        { field: 'poBalanceQuantity', headerName: 'Balance Quantity (MT)', flex: 1 },
        { field: 'planningNumber', headerName: 'Planning Number', flex: 1 },
        {
            field: 'poShortCloseQuantity',
            headerName: 'Short Close Quantity',
            flex: 1,
            renderCell: (params) => (
                <div>
                    <TextField id="standard-basic" variant="standard" sx={{ padding: 0 }}
                        type="number"
                        onFocus={handleNumberFieldFocus}
                        value={params.row.poShortCloseQuantity}
                        onChange={(e) => handleQuantityChange(params.row.id, e.target.value)}
                        disabled={!params.row.isChecked}

                    />
                    {/* {shortCloseQtyValidation && params.row.error && <p style={{ color: 'red' }}>{params.row.error}</p>} */}
                </div>

            ),
        },

    ];




    const ExpectedChipQuantity = inventoryLevel?.unrestrictedRBInventory ? Number((inventoryLevel?.unrestrictedRBInventory / rbRbRation).toFixed(2)) : 0

    useEffect(() => {
        if (destinationStakeholderType) {
            onDestinationStakeholderTypeChange();
        }
    }, [destinationStakeholderType]);

    useEffect(() => {
        if (sourceStakeholderType) {
            onSourceStakeholderTypeChange();
        }
    }, [sourceStakeholderType]);

    const onDestinationStakeholderTypeChange = () => {
        setDestinationStakeholderDetails(null);
        loaderService.showLoader();
        apiClient.post(FETCH_MAPPED_STAKEHOLDER_BY_TYPE_URN,
            {
                "stakeholderType": poStakeholderType,
                "stakeholderUrn": searchTerm
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                if (destinationStakeholderType === "LLE") {
                    setDestinationUrnList(response.data.llleMappedPojo);
                }
                if (destinationStakeholderType === "Interim Storage Operator") {
                    setDestinationUrnList(response.data.isMappedPojo)
                }
                if (destinationStakeholderType === "Plant") {
                    setDestinationUrnList(response.data.plantMappedPojo);
                }

                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const onSourceStakeholderTypeChange = () => {
        setSourceStakeholderDetails(null);
        loaderService.showLoader();
        apiClient.post(FETCH_MAPPED_STAKEHOLDER_BY_TYPE_URN,
            {
                "stakeholderType": poStakeholderType,
                "stakeholderUrn": searchTerm
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                if (sourceStakeholderType === "LLE") {
                    setSourceUrnList(response.data.llleMappedPojo);
                }
                if (sourceStakeholderType === "Interim Storage Operator") {
                    setSourceUrnList(response.data.isMappedPojo)
                }
                if (sourceStakeholderType === "Plant") {
                    setSourceUrnList(response.data.plantMappedPojo);
                }

                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    // useEffect(() => {
    //     const uniqueValues = Array.from(new Set(destinationUrnList?.map(item => item.stakeholderUrn)));
    //     const distinctObjects = uniqueValues?.map(value => { return destinationUrnList.find(item => item.stakeholderUrn === value); });
    //    console.log("distinctObjects", distinctObjects)
    //     setDistinctDestinationUrnValues(distinctObjects);
    // }, [destinationUrnList]);

    // useEffect(() => {
    //     const uniqueValues = Array.from(new Set(sourceUrnList?.map(item => item.stakeholderUrn)));
    //     const distinctObjects = uniqueValues?.map(value => { return sourceUrnList.find(item => item.stakeholderUrn === value); });
    //     setDistinctSourceUrnValues(distinctObjects);
    // }, [sourceUrnList]);

    const onDestinationTypeChange = (e) => {
        setDestinationStakeholderType(e.target.value);
        setErrorMessage({ ...errorMessage, destinationStakeholderTypeError: "" });
        setDestinationStakeholderUrn("");
        setDestinationUrnList([]);
        getHITPlanningNumberList(financialYear, monthChange, searchTerm, e.target.value, destinationStakeholderUrn);
    }


    const onSourceTypeChange = (e) => {
        setSourceStakeholderType(e.target.value);
        setErrorMessage({ ...errorMessage, sourceStakeholderTypeError: "" });
        setSourceStakeholderUrn("");
        setSourceUrnList([]);
    }

    const onDestinationUrnChange = (e) => {
        setDestinationStakeholderUrn(e.target.value);

        if (destinationStakeholderType === "Plant") {
            setDestinationStakeholderDetails({ name: PLANT_STATIC_NAME });
        } else {
            getStakeholderBasicDetails(
                e.target.value,
                destinationStakeholderType,
                setDestinationStakeholderDetails
            );
        }

        poStakeholderType === "Transporter" && getDistanceTravelled(sourceStakeholderUrn, e.target.value);
        planningNumber && poStakeholderType === "HIT" && manualPoDetails?.serviceStakeholderType === "Transporter" && getAverageDistance(sourceStakeholderUrn, e.target.value, planningNumber === "Other" ? otherPlanningNumber : planningNumber);
        getHITPlanningNumberList(financialYear, monthChange, searchTerm, destinationStakeholderType, e.target.value);
        setErrorMessage({ ...errorMessage, destinationStakeholderUrnError: "" });
    }

    const onSourceUrnChange = (e) => {
        setSourceStakeholderUrn(e.target.value);

        getStakeholderBasicDetails(
            e.target.value,
            sourceStakeholderType,
            setSourceStakeholderDetails
        );

        destinationStakeholderUrn && poStakeholderType === "Transporter" && getDistanceTravelled(e.target.value, destinationStakeholderUrn);
        planningNumber && destinationStakeholderUrn && poStakeholderType === "HIT" && manualPoDetails?.serviceStakeholderType === "Transporter" && getAverageDistance(e.target.value, destinationStakeholderUrn, planningNumber === "Other" ? otherPlanningNumber : planningNumber);
        getHITPlanningNumberList(financialYear, monthChange, searchTerm, sourceStakeholderType, e.target.value);
        setErrorMessage({ ...errorMessage, sourceStakeholderUrnError: "" });
    }

    const onUploadCallBack = (docArray) => {
        setDocumentsArray(docArray);
    }

    useEffect(() => {
        getRbCbRatio();
    }, []);

    const getRbCbRatio = () => {
        loaderService.showLoader();
        apiClient.post(RB_CB_RATIO,
            null,
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setRbRbRation(response.data?.value);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    // useEffect(() => {
    //     getTaxData();
    // }, []);

    const getTaxData = (stakeholderUrn) => {
        loaderService.showLoader();
        apiClient.post(GET_TAX_DETAILS,
            {
                "stakeholderUrn": stakeholderUrn,
                "stakeholderType": poStakeholderType,
                "poActivityType": ""
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setGetTaxDetails(response.data);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getPoPreview = (groData) => {
        if (!financialYear) {
            toast.error("Select Financial Year")
        }
        else if (!monthChange) {
            toast.error("Select Month")
        }
        // else if (!planningNumber || !otherPlanningNumber) {
        //     toast.error("Select Planning Number")
        // }
        else if (!poMaterialType) {
            toast.error("Select Material Type")
        }
        else if (!poType) {
            toast.error("Select PO Type")
        }
        else if (!poValidityDate) {
            toast.error("PO Validity Date is required")
        }
        else if (poStakeholderType === "Transporter" && !sourceStakeholderType) {
            toast.error("Select Source Type")
        }
        else if (poStakeholderType === "Transporter" && !sourceStakeholderUrn) {
            toast.error("Select Source URN")
        }
        else if (poStakeholderType !== "LLE" && poStakeholderType !== "Grower" && poStakeholderType !== "Plant" && !destinationStakeholderType) {
            toast.error("Select Destination Type")
        }
        else if (poStakeholderType !== "LLE" && poStakeholderType !== "Grower" && poStakeholderType !== "Plant" && !destinationStakeholderUrn) {
            toast.error("Select Destination URN")
        }
        else if ((poStakeholderType === "Transporter" || (poStakeholderType === "HIT" && manualPoDetails.serviceStakeholderType === "Transporter")) && !distanceTravelled) {
            toast.error("Enter distance travelled")
            setErrorMessage({ ...errorMessage, distanceTravelledError: "Distance Travelled should be more than 0" })
        }
        else {
            loaderService.showLoader();
            apiClient
                .post(
                    GET_PO_PREVIEW,
                    {
                        "poDescription": payloadWithNewline,
                        "poMaterialType": poMaterialType,
                        "poType": poType,
                        "poStakeholderType": groData?.stakeholderType ? groData?.stakeholderType : poStakeholderType,
                        "poStakeholderUrn": groData?.stakeholderUrn ? groData?.stakeholderUrn : searchTerm,
                        "landId": groData?.landId,
                        "landName": groData?.landName,
                        "poQuantity": groData?.poQuantity ? groData?.poQuantity : poStakeholderType === "HIT" ? shortCloseQty : poQuantity,
                        "destinationStakeholderType": groData?.destinationStakeholderType ? groData?.destinationStakeholderType : destinationStakeholderType,
                        "destinationStakeholderUrn": groData?.destinationStakeholderUrn ? groData?.destinationStakeholderUrn : destinationStakeholderUrn,
                        "sourceStakeholderType": groData?.sourceStakeholderType ? groData?.sourceStakeholderType : sourceStakeholderType,
                        "sourceStakeholderUrn": groData?.sourceStakeholderUrn ? groData?.sourceStakeholderUrn : sourceStakeholderUrn,
                        "financialYear": financialYear,
                        "month": monthChange,
                        "planningNumber": planningNumber === "Other" ? otherPlanningNumber : planningNumber,
                        "poUnitOfMeasure": "MT",
                        "poUnitPrice": groData?.rate,
                        "totalCost": groData?.totalAmount,
                        "distanceTravelled": distanceTravelled,
                        "poSubject": poSubject,
                        "poValidityDate": poValidityDate

                    },
                    {
                        headers: {
                            Authorization: "Bearer " + getLocalStorageItem('id_token'),
                        },
                    }
                )
                .then((response) => {
                    if (response.data) {
                        if (response.data.isSuccess) {
                            setOpen(true);
                            setPreviewDetails(response.data.poDetails);
                        }
                        else toast.error(response.data.message)
                    }
                    else toast.error("Error! Please try again!")
                    loaderService.hideLoader();
                })
                .catch(function (error) {
                    console.log("apiClientERROR", error);
                    loaderService.hideLoader();
                    toast.error(error.message);
                });
        }

    };

    const handleStockCheckboxChange = (e) => {
        setIsChecked(!isChecked)
    }
    const handleSpotBiddingCheckboxChange = (e) => {
        setIsCheckedBidding(!isCheckedBidding)
    }

    const getStakeholderDisplayName = (stakeholder) => {
        if (!stakeholder) return '';

        if (stakeholder.subCategory === 'Individual') {
            return [
                stakeholder.firstName,
                stakeholder.middleName,
                stakeholder.lastName,
            ]
                .filter(Boolean)
                .join(' ');
        }

        return stakeholder.name || '';
    };

    const getStakeholderBasicDetails = async (urn, type, setState) => {
        if (!urn || !type) return;

        const data = { urn, type };
        const headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        };

        loaderService.showLoader();

        try {
            const res = await apiClient.post(
                GET_STAKEHOLDER_BASIC_DETAILS_URN,
                data,
                { headers }
            );

            setState(res.data?.stakeHolders?.[0] || null);
        } catch (err) {
            toast.error(err.message);
        } finally {
            loaderService.hideLoader();
        }
    };

    const getGrowerOptionLabel = (opt) => {
        if (
            poStakeholderType === "Grower" &&
            opt?.subCategory === "Individual"
        ) {
            const fullName = [
                opt.firstName,
                opt.middleName,
                opt.lastName,
            ].filter(Boolean).join(" ");

            return `${opt.urn} - ${fullName}`;
        }

        return `${opt.urn} - ${opt.name || ""}`;
    };

    const getDefaultSubject = (stakeholder, serviceType) => {
        const type = stakeholder?.toLowerCase();
        const service = serviceType?.toLowerCase();

        if (type === "grower") return "Bamboo Procurement";
        if (type === "lle") return "Bamboo Chipping Service";
        if (type === "transporter") return "Chips Transportation Service";

        if (type === "hit") {
            if (service === "harvester") return "Harvesting Service";
            if (service === "transporter") return "Raw Bamboo Transportation Service";
        }

        return "";
    };

    useEffect(() => {
        const defaultValue = getDefaultSubject(
            poStakeholderType,
            manualPoDetails?.serviceStakeholderType
        );

        setPoSubject(prev => {
            const defaultValuesList = [
                "Bamboo Procurement",
                "Bamboo Chipping Service",
                "Chips Transportation Service",
                "Harvesting Service",
                "Raw Bamboo Transportation Service"
            ];

            if (!prev || defaultValuesList.includes(prev)) {
                return defaultValue;
            }

            return prev;
        });

    }, [poStakeholderType, manualPoDetails?.serviceStakeholderType]);

    const handlePoValidityChange = (value) => {
        const formatted = value ? value.format("YYYY-MM-DD") : null;
        setPoValidityDate(formatted);
        setErrorMessage((prev) => ({
            ...prev,
            poValidityDateError: ""
        }));
    };

    return (
        <>
            <Container maxWidth="xxl">
                {/* {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT66</p>} */}
                <Typography variant="h4" sx={{ mb: 2 }}>
                    Manual PO Creation
                </Typography>
                <Grid container spacing={1} direction="row">
                    <Grid item xs={12} lg={6}>
                        <Checkbox checked={isChecked} onChange={(e) => handleStockCheckboxChange(e)} />
                        <Typography variant='subtitle'>Is Stock Transfer Request?</Typography>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <Checkbox checked={isCheckedBidding} onChange={(e) => handleSpotBiddingCheckboxChange(e)} />
                        <Typography variant='subtitle'>Is Spot Bidding Allotment Request?</Typography>
                    </Grid>
                </Grid>

                {
                    isChecked === true ?
                        <SOCreation />
                        : isCheckedBidding ?
                            <SpotBiddingPoCreation />
                            : <>
                                <Card>
                                    <CardContent>
                                        <Grid container spacing={1} direction="row" mt={1}>
                                            <Grid item xs={12}>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12} lg={4}>
                                                        <FormControl fullWidth size="small" required error={errorMessage.financialYearError}>
                                                            <InputLabel>Financial Year</InputLabel>
                                                            <Select label="Financial Year" value={financialYear || ''} name="financialYear" onChange={(e) => onFinancialYearChange(e)}>
                                                                <MenuItem><em>Financial Year</em></MenuItem>
                                                                {sortedYears &&
                                                                    sortedYears.map((items) => (
                                                                        <MenuItem value={items}>{items}</MenuItem>
                                                                    ))}
                                                            </Select>
                                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.financialYearError}</FormHelperText>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} lg={4}>
                                                        <FormControl fullWidth size="small" required error={errorMessage.monthError}>
                                                            <InputLabel>Month</InputLabel>
                                                            <Select required label="Month" value={monthChange || ''} name="month" onChange={(e) => onMonthChange(e)}>
                                                                <MenuItem><em>Month</em></MenuItem>
                                                                <MenuItem value="Jan">January</MenuItem>
                                                                <MenuItem value="Feb">February</MenuItem>
                                                                <MenuItem value="Mar">March</MenuItem>
                                                                <MenuItem value="Apr">April</MenuItem>
                                                                <MenuItem value="May">May</MenuItem>
                                                                <MenuItem value="Jun">June</MenuItem>
                                                                <MenuItem value="Jul">July</MenuItem>
                                                                <MenuItem value="Aug">August</MenuItem>
                                                                <MenuItem value="Sep">September</MenuItem>
                                                                <MenuItem value="Oct">October</MenuItem>
                                                                <MenuItem value="Nov">November</MenuItem>
                                                                <MenuItem value="Dec">December</MenuItem>
                                                            </Select>
                                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.monthError}</FormHelperText>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} lg={4}>
                                                        <FormControl fullWidth size="small" required error={errorMessage.poStakeholderTypeError}>
                                                            <InputLabel>Stakeholder Type</InputLabel>
                                                            <Select label="Stakeholder Type" name="poStakeholderType" value={poStakeholderType || ''} onChange={(e) => onTypeChange(e)}>
                                                                <MenuItem><em>Stakeholder Type</em></MenuItem>
                                                                <MenuItem value="Grower">Grower</MenuItem>
                                                                <MenuItem value="HIT">HIT</MenuItem>
                                                                <MenuItem value="LLE">LLE</MenuItem>
                                                                <MenuItem value="Transporter">Transporter</MenuItem>
                                                                <MenuItem value="Plant">Plant</MenuItem>
                                                                {/* <MenuItem value="Interim Storage Operator">ISO</MenuItem> */}
                                                            </Select>
                                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.poStakeholderTypeError}</FormHelperText>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} lg={4} hidden={poStakeholderType === "HIT"}>
                                                        <FormControl fullWidth size="small" required error={errorMessage.planningNumberError}>
                                                            <InputLabel>Planning Number</InputLabel>
                                                            <Select label="Planning Number" name="planningNumber" value={planningNumber || ''} onChange={(e) => onPlanningNumberChange(e)}>
                                                                <MenuItem><em>Planning Number</em></MenuItem>
                                                                {planningNumberList &&
                                                                    planningNumberList.map((items) => (
                                                                        <MenuItem value={items}>{items}</MenuItem>

                                                                    ))}
                                                                <MenuItem value="Other">Other</MenuItem>
                                                            </Select>
                                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.planningNumberError}</FormHelperText>
                                                        </FormControl>
                                                    </Grid>
                                                    {
                                                        planningNumber === 'Other' &&
                                                        <Grid item xs={12} lg={4}>
                                                            <TextField fullWidth size="small"
                                                                type="text"
                                                                name="otherPlanningNumber"
                                                                label="Other Planning Number"
                                                                value={otherPlanningNumber || ''}
                                                                disabled
                                                            />
                                                        </Grid>
                                                    }

                                                    <Grid item xs={12} lg={4}>
                                                        <FormControl fullWidth size="small" required error={errorMessage.poTypeError}>
                                                            <InputLabel>PO Type</InputLabel>
                                                            <Select label="PO Type" name="poType" value={poType || ''} onChange={(e) => onPoTypeChange(e)}>
                                                                <MenuItem><em>PO Type</em></MenuItem>
                                                                {filteredOptions().map(option => (
                                                                    <MenuItem key={option.value} value={option.value}>
                                                                        {option.label}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.poTypeError}</FormHelperText>
                                                        </FormControl>

                                                    </Grid>
                                                    {
                                                        poType === "SO" &&
                                                        <Grid item xs={12} lg={4}>
                                                            <FormControl fullWidth size="small" required error={errorMessage?.serviceStakeholderTypeError}>
                                                                <InputLabel>SO Type</InputLabel>
                                                                <Select label="SO Type" name="serviceStakeholderType" value={manualPoDetails?.serviceStakeholderType || ''} onChange={(e) => handleChange(e)}>
                                                                    <MenuItem><em>SO Type</em></MenuItem>
                                                                    {filteredSoTypeOptions().map(option => (
                                                                        <MenuItem key={option.value} value={option.value}>
                                                                            {option.label}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                                <FormHelperText sx={{ color: 'red' }}>{errorMessage.serviceStakeholderTypeError}</FormHelperText>
                                                            </FormControl>

                                                        </Grid>

                                                    }
                                                    {
                                                        poType === "SCO" &&
                                                        <Grid item xs={12} lg={4}>
                                                            <FormControl fullWidth size="small" required error={errorMessage?.serviceStakeholderTypeError}>
                                                                <InputLabel>SCO Type</InputLabel>
                                                                <Select label="SO Type" name="serviceStakeholderType" value={manualPoDetails?.serviceStakeholderType || ''} onChange={(e) => handleChange(e)}>
                                                                    <MenuItem><em>SCO Type</em></MenuItem>
                                                                    <MenuItem value="Chipping">Chipping</MenuItem>
                                                                </Select>
                                                                <FormHelperText sx={{ color: 'red' }}>{errorMessage.serviceStakeholderTypeError}</FormHelperText>
                                                            </FormControl>

                                                        </Grid>

                                                    }

                                                    <Grid item xs={12} lg={4}>
                                                        <FormControl fullWidth size="small" required error={errorMessage.poMaterialTypeError}>
                                                            <InputLabel>Material Type</InputLabel>
                                                            <Select label="PO Material Type" name="poMaterialType" value={poMaterialType || ''} onChange={(e) => onPoMaterialTypeChange(e)}>
                                                                <MenuItem><em>Material Type</em></MenuItem>
                                                                {filteredMaterialTypeOptions().map(option => (
                                                                    <MenuItem key={option.value} value={option.value}>
                                                                        {option.label}
                                                                    </MenuItem>
                                                                ))}

                                                            </Select>
                                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.poMaterialTypeError}</FormHelperText>
                                                        </FormControl>
                                                    </Grid>

                                                </Grid>
                                                <Grid item xs={12} mt={3}>
                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12} lg={4}>
                                                            <TextField
                                                                fullWidth
                                                                id="outlined-multiline-static"
                                                                size="small"
                                                                label="PO Subject"
                                                                name="poSubject"
                                                                multiline
                                                                rows={3}
                                                                value={poSubject || ''}
                                                                onChange={(e) => setPoSubject(e.target.value)}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} lg={4}>
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DesktopDatePicker
                                                                    label="PO Validity Date"
                                                                    value={poValidityDate ? dayjs(poValidityDate) : null}
                                                                    inputFormat="DD/MM/YYYY"
                                                                    onChange={(newValue) => handlePoValidityChange(newValue)}
                                                                    disablePast
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            fullWidth
                                                                            size="small"
                                                                            required
                                                                            error={!!errorMessage?.poValidityDateError}
                                                                            helperText={errorMessage?.poValidityDateError}
                                                                        />
                                                                    )}
                                                                />
                                                            </LocalizationProvider>
                                                        </Grid>

                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12} mt={2}>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12} lg={6}>
                                                        <TextField fullWidth
                                                            // error={errorMessage.poDescriptionError}
                                                            // helperText={errorMessage.poDescriptionError}
                                                            autoComplete="off"
                                                            id="outlined-multiline-static"
                                                            type="text"
                                                            name="poDescription"
                                                            label="Terms & Conditions"
                                                            value={manualPoDetails?.poDescription || ''}
                                                            multiline
                                                            rows={4}
                                                            onChange={(e) => handleChange(e)}
                                                        />
                                                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                            <Badge>{manualPoDetails?.poDescription?.length}</Badge>
                                                        </div>
                                                        {/* <div dangerouslySetInnerHTML={{__html: payloadWithNewline}}></div> */}
                                                    </Grid>
                                                    <Grid item xs={12} lg={6}>
                                                        <FileUploadMUI key="poSupportingDoc"
                                                            documentList={documentsArray}
                                                            documentType="poSupportingDoc"
                                                            callBackDocumentUpload={onUploadCallBack}
                                                            title="Upload Supporting Document"
                                                            containerName="pit"
                                                            errorMessage={errorMessage}
                                                            setErrorMessage={setErrorMessage}
                                                            documentError="fileError"
                                                        />
                                                        {/* <Typography variant="body1">Upload Supporting Document</Typography>
                                        <label className="chooseFile-create-rateCard">
                                            <input style={{ display: "none" }} type="file" accept="image/jpeg, image/jpg, image/png, .pdf" name="" onChange={(e) => uploadNocDoc(e)} />Upload File
                                            <label className="documentName-create-pickupdetails">{selectedFile?.name}</label>
                                            <div className='mandatory_field'>{errorMessage.fileError}</div>
                                            <Typography variant="subtitle2" fontSize="1.8vh" align="left" color="green">(upload only .png, .jpg, .jpeg, .pdf, files.File size limit=5MB)</Typography>
                                        </label> */}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Divider sx={{
                                                width: '105%',
                                                bgcolor: 'black',
                                                marginTop: '3vh'
                                            }} mt={2} />
                                            {
                                                poStakeholderType === "Grower" &&
                                                <Grid item xs={12}>
                                                    <Typography variant="subtitle1" sx={{ mb: 1, mt: 1 }}>Select Grower for {poType} Creation</Typography>
                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12} lg={4}>
                                                            <Autocomplete
                                                                value={urns.find(o => o.urn === searchTerm) || null}
                                                                getOptionLabel={(opt) => getGrowerOptionLabel(opt)}
                                                                isOptionEqualToValue={(opt, val) => opt.urn === val.urn}
                                                                onChange={(_, newValue) => {
                                                                    const urn = newValue?.urn ?? "";
                                                                    setSearchTerm(urn);
                                                                    handleSearch(newValue);
                                                                    setSelectedStakeholder(newValue);
                                                                    getGrowerLandList(urn);
                                                                    setDestinationStakeholderType('');
                                                                    setDestinationStakeholderUrn('');
                                                                    setDestinationUrnList([]);
                                                                    setSourceStakeholderType('');
                                                                    setSourceStakeholderUrn('');
                                                                    setSourceUrnList([]);
                                                                    setSourceStakeholderDetails(null);
                                                                    setDestinationStakeholderDetails(null);
                                                                    setErrorMessage({ ...errorMessage, searchUrnError: "" });
                                                                }}
                                                                options={urns || []}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Search URN"
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        size="small"
                                                                        required
                                                                        error={errorMessage.searchUrnError}
                                                                        helperText={errorMessage.searchUrnError}
                                                                    />
                                                                )}
                                                            />

                                                        </Grid>
                                                        {selectedStakeholder && (
                                                            <Grid item xs={12} lg={4}>
                                                                <TextField
                                                                    label="Stakeholder Name"
                                                                    value={getStakeholderDisplayName(selectedStakeholder)}
                                                                    fullWidth
                                                                    size="small"
                                                                    InputProps={{ readOnly: true }}
                                                                />
                                                            </Grid>
                                                        )}

                                                        <Grid item xs={12} lg={4}>
                                                            <FormControl fullWidth size="small" required error={errorMessage.landNameError}>
                                                                <InputLabel>Land Name</InputLabel>
                                                                <Select label="Land Name" name="landName" value={selectedLandId || ''} onChange={(e) => onLandNameChange(e)}>
                                                                    {growerLandList &&
                                                                        growerLandList?.map((items) => (
                                                                            <MenuItem value={items.landId}>{items.landName}</MenuItem>

                                                                        ))}

                                                                </Select>
                                                                <FormHelperText sx={{ color: 'red' }}>{errorMessage.landNameError}</FormHelperText>
                                                            </FormControl>

                                                        </Grid>

                                                        <Grid item xs={12} lg={4}>
                                                            <TextField fullWidth required size="small"
                                                                error={errorMessage.poQuantityError}
                                                                helperText={errorMessage.poQuantityError}
                                                                type="number"
                                                                onFocus={handleNumberFieldFocus}
                                                                // name="poQuantity"
                                                                label="PO Quantity (MT)"
                                                                value={poQuantity || ''}
                                                                onChange={(e) => onPoQuantityChange(e)}
                                                                onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')' || evt.key === 'e') && evt.preventDefault()}
                                                                inputProps={{
                                                                    maxLength: 10
                                                                }}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} lg={4}>
                                                            <FormControl fullWidth size="small" required={errorMessage.destinationStakeholderTypeError}>
                                                                <InputLabel>Destination Stakeholder Type</InputLabel>
                                                                <Select label="Desination Stakeholder Type" name="secondPartyType" value={destinationStakeholderType || ''} onChange={(e) => onDestinationTypeChange(e)}>
                                                                    <MenuItem value="LLE">LLE</MenuItem>
                                                                    <MenuItem value="InterimStorageOperator">IS</MenuItem>
                                                                    <MenuItem value="Plant">Plant</MenuItem>
                                                                </Select>
                                                                <FormHelperText sx={{ color: 'red' }}>{errorMessage.destinationStakeholderTypeError}</FormHelperText>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={12} lg={4}>
                                                            <FormControl fullWidth size="small" required error={errorMessage.destinationStakeholderUrnError}>
                                                                <InputLabel>Destination Stakeholder URN</InputLabel>
                                                                <Select label="Destination Stakeholder URN" value={destinationStakeholderUrn || ''} name="secondPartyUrn" onChange={(e) => onDestinationUrnChange(e)}>

                                                                    {destinationUrnList &&
                                                                        (poStakeholderType === "Grower" ? destinationUrnList?.filter(item => item.landId === selectedLandId) : destinationUrnList)?.map((items) => (
                                                                            <MenuItem value={items.stakeholderUrn}>{items.stakeholderUrn}</MenuItem>

                                                                        ))}
                                                                </Select>
                                                                <FormHelperText sx={{ color: 'red' }}>{errorMessage.destinationStakeholderUrnError}</FormHelperText>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={12} lg={4}>
                                                            <TextField
                                                                label="Destination Stakeholder Name"
                                                                value={destinationStakeholderDetails?.name || ''}
                                                                fullWidth
                                                                size="small"
                                                                InputProps={{ readOnly: true }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} lg={4}>
                                                            <Button variant="contained"
                                                                color="primary"
                                                                startIcon={<AddIcon />}
                                                                onClick={handleAddButtonClick}
                                                            >
                                                                Add
                                                            </Button>
                                                        </Grid>
                                                        <Grid item xs={12} lg={12}>
                                                            <Typography sx={{ color: 'red' }}>{errorMessage.growerPoDuplicateError}</Typography>
                                                            {
                                                                addedGrowerPo?.length !== 0 &&
                                                                <Box style={{ height: 350, width: '100%' }}>
                                                                    <DataGrid
                                                                        rows={addedGrowerPo}
                                                                        columns={columns2}
                                                                        pageSize={5}
                                                                        getRowId={(row) => row?.landId}

                                                                    />
                                                                </Box>
                                                            }

                                                        </Grid>
                                                    </Grid>

                                                </Grid>

                                            }
                                            {
                                                poStakeholderType === "HIT" &&

                                                <Grid item xs={12}>
                                                    <Typography variant="subtitle1" sx={{ mb: 1, mt: 1 }}>Select HIT for {poType} Creation</Typography>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} lg={12}>
                                                            <FormControl fullWidth required error={errorMessage?.isShortCloseError}>
                                                                <FormLabel id="demo-row-radio-buttons-group-label">Short Close Previous PO</FormLabel>
                                                                <RadioGroup
                                                                    row
                                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                                    name="row-radio-buttons-group"
                                                                >
                                                                    <FormControlLabel name="isShortClosePreviousPO" disabled checked={isShortClosePreviousPO === true} onChange={(e) => radioChange(e, true)} control={<Radio />} label="Yes" />
                                                                    <FormControlLabel name="isShortClosePreviousPO" checked={isShortClosePreviousPO === false} onChange={(e) => radioChange(e, false)} control={<Radio />} label="No" />
                                                                </RadioGroup>
                                                                <FormHelperText sx={{ color: 'red' }}>{errorMessage?.isShortCloseError}</FormHelperText>
                                                            </FormControl>
                                                        </Grid>
                                                        {isShortClosePreviousPO === true &&
                                                            <>
                                                                <Grid item xs={12} lg={3}>
                                                                    <Autocomplete
                                                                        value={urns.find(o => o.urn === searchTerm) || null}
                                                                        getOptionLabel={(opt) => `${opt.urn} - ${opt.name}`}
                                                                        isOptionEqualToValue={(opt, val) => opt.urn === val.urn}
                                                                        onInputChange={(_, newValue) => {
                                                                            const urn = newValue?.urn ?? "";
                                                                            setSearchTerm(urn);
                                                                            handleSearch(newValue);
                                                                            setSelectedStakeholder(newValue);
                                                                            getGrowerHitMappedPO(urn);
                                                                            setDestinationStakeholderType('');
                                                                            setDestinationStakeholderUrn('');
                                                                            setDestinationUrnList([]);
                                                                            setSourceStakeholderType('');
                                                                            setSourceStakeholderUrn('');
                                                                            setSourceUrnList([]);
                                                                            setErrorMessage({ ...errorMessage, searchUrnError: "" });
                                                                        }}
                                                                        options={urns || []}
                                                                        renderInput={(params) => (
                                                                            <TextField
                                                                                {...params}
                                                                                label="Search URN"
                                                                                variant="outlined"
                                                                                fullWidth
                                                                                size="small"
                                                                                required error={errorMessage.searchUrnError} helperText={errorMessage.searchUrnError}
                                                                                InputProps={{
                                                                                    ...params.InputProps,
                                                                                    endAdornment: (
                                                                                        <>
                                                                                            {searchTerm && (
                                                                                                <ClearIcon
                                                                                                    style={{ cursor: 'pointer' }}
                                                                                                    onClick={handleClear}
                                                                                                />
                                                                                            )}
                                                                                        </>
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        )}
                                                                    />
                                                                </Grid>
                                                                {selectedStakeholder && (
                                                                    <Grid item xs={12} lg={4}>
                                                                        <TextField
                                                                            label="Stakeholder Name"
                                                                            value={getStakeholderDisplayName(selectedStakeholder)}
                                                                            fullWidth
                                                                            size="small"
                                                                            InputProps={{ readOnly: true }}
                                                                        />
                                                                    </Grid>
                                                                )}

                                                                <Grid item xs={12} lg={3}>
                                                                    <FormControl fullWidth size="small" required={errorMessage.destinationStakeholderTypeError}>
                                                                        <InputLabel>Destination Stakeholder Type</InputLabel>
                                                                        <Select label="Desination Stakeholder Type" name="secondPartyType" value={destinationStakeholderType || ''} onChange={(e) => onDestinationTypeChange(e)}>
                                                                            <MenuItem value="LLE">LLE</MenuItem>
                                                                            <MenuItem value="InterimStorageOperator">IS</MenuItem>
                                                                            <MenuItem value="Plant">Plant</MenuItem>
                                                                        </Select>
                                                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage.destinationStakeholderTypeError}</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} lg={3}>
                                                                    <FormControl fullWidth size="small" required error={errorMessage.destinationStakeholderUrnError}>
                                                                        <InputLabel>Destination Stakeholder URN</InputLabel>
                                                                        <Select label="Destination Stakeholder URN" value={destinationStakeholderUrn || ''} name="secondPartyUrn" onChange={(e) => onDestinationUrnChange(e)}>

                                                                            {destinationUrnList &&
                                                                                destinationUrnList?.map((items) => (
                                                                                    <MenuItem value={items.stakeholderUrn}>{items.stakeholderUrn}</MenuItem>

                                                                                ))}
                                                                        </Select>
                                                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage.destinationStakeholderUrnError}</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} lg={4}>
                                                                    <TextField
                                                                        label="Destination Stakeholder Name"
                                                                        value={destinationStakeholderDetails?.name || ''}
                                                                        fullWidth
                                                                        size="small"
                                                                        InputProps={{ readOnly: true }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} lg={3}>
                                                                    <TextField fullWidth required size="small"
                                                                        error={errorMessage.totalShortCloseQtyError}
                                                                        helperText={errorMessage.totalShortCloseQtyError}
                                                                        type="number"
                                                                        onFocus={handleNumberFieldFocus}
                                                                        name="totalShortCloseQuantity"
                                                                        label="Short Close Quantity"
                                                                        value={totalQuantity || ''}
                                                                        disabled
                                                                    />
                                                                </Grid>

                                                                {
                                                                    mappedGrowerPoList &&
                                                                    <Grid item xs={12} lg={12}>
                                                                        <Typography sx={{ mb: 1, color: 'red' }}>{errorMessage.noPoSelectedError}</Typography>
                                                                        <Typography sx={{ color: 'red' }}>{errorMessage.poShortCloseQuantityError}</Typography>
                                                                        <Box style={{ height: 350, width: '100%' }} sx={{
                                                                            height: 450,
                                                                            '& .super-app-theme--header': {
                                                                                wordWrap: 'break-word',
                                                                                wordBreak: 'break-all',
                                                                                whiteSpace: 'initial',
                                                                            },
                                                                            '& .MuiDataGrid-cell--editable': {
                                                                                bgcolor: (theme) =>
                                                                                    theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                                                                            },
                                                                            '& .super-app.confirmationStatusPending': {
                                                                                backgroundColor: '#FFFF8F',
                                                                                color: '#1a3e72',
                                                                                fontWeight: '600',
                                                                            },
                                                                            '& .super-app.confirmationStatusRejected': {
                                                                                backgroundColor: '#F88379',
                                                                                color: '#1a3e72',
                                                                                fontWeight: '600',
                                                                            },
                                                                            '& .super-app.confirmationStatusConfirmed': {
                                                                                backgroundColor: '#ECFFDC',
                                                                                color: 'green',
                                                                                fontWeight: '600',
                                                                            },
                                                                            '& .themeFailure': {
                                                                                backgroundColor: '#FF7F7F',
                                                                                color: '#1a3e72',
                                                                            },
                                                                            '& .Mui-error': {
                                                                                backgroundColor: `rgb(126,10,15,0.1)`,
                                                                                color: (theme) => theme.palette.error.main,
                                                                            },
                                                                        }}>

                                                                            <DataGrid
                                                                                rows={mappedGrowerPoList}
                                                                                columns={columns}
                                                                                pageSize={5}
                                                                                // checkboxSelection
                                                                                disableSelectionOnClick
                                                                                components={{ Toolbar: QuickSearchToolbar }}
                                                                            // processRowUpdate={(e) => handleCheckboxChange(e)}
                                                                            // getCellClassName={(params) => {
                                                                            //     return (params.row.isChecked === true) && !params.row.poShortCloseQuantity && 'themeFailure';
                                                                            // }}
                                                                            />

                                                                        </Box>
                                                                    </Grid>
                                                                }
                                                            </>
                                                        }
                                                        {
                                                            isShortClosePreviousPO === false &&
                                                            <>
                                                                <Grid item xs={12} lg={4}>
                                                                    <Autocomplete
                                                                        value={urns.find(o => o.urn === searchTerm) || null}
                                                                        getOptionLabel={(opt) => `${opt.urn} - ${opt.name}`}
                                                                        isOptionEqualToValue={(opt, val) => opt.urn === val.urn}
                                                                        onChange={(_, newValue) => {
                                                                            const urn = newValue?.urn ?? "";
                                                                            setSearchTerm(urn);
                                                                            handleSearch(newValue);
                                                                            setSelectedStakeholder(newValue);
                                                                            getHITPlanningNumberList(financialYear, monthChange, urn, destinationStakeholderType, destinationStakeholderUrn);
                                                                            setDestinationStakeholderType('');
                                                                            setDestinationStakeholderUrn('');
                                                                            setDestinationUrnList([]);
                                                                            setSourceStakeholderType('');
                                                                            setSourceStakeholderUrn('');
                                                                            setSourceUrnList([]);
                                                                            setErrorMessage({ ...errorMessage, searchUrnError: "" });
                                                                        }}
                                                                        options={urns || []} // Ensure options is an array, even if it's initially undefined
                                                                        renderInput={(params) => (
                                                                            <TextField {...params} label="Search URN" variant="outlined" fullWidth size="small"
                                                                                required error={errorMessage.searchUrnError} helperText={errorMessage.searchUrnError} />
                                                                        )}
                                                                    />
                                                                </Grid>
                                                                {selectedStakeholder && (
                                                                    <Grid item xs={12} lg={4}>
                                                                        <TextField
                                                                            label="Stakeholder Name"
                                                                            value={getStakeholderDisplayName(selectedStakeholder)}
                                                                            fullWidth
                                                                            size="small"
                                                                            InputProps={{ readOnly: true }}
                                                                        />
                                                                    </Grid>
                                                                )}

                                                                <Grid item xs={12} lg={4}>
                                                                    <FormControl fullWidth size="small" required={errorMessage.destinationStakeholderTypeError}>
                                                                        <InputLabel>Destination Stakeholder Type</InputLabel>
                                                                        <Select label="Desination Stakeholder Type" name="secondPartyType" value={destinationStakeholderType || ''} onChange={(e) => onDestinationTypeChange(e)}>
                                                                            <MenuItem value="LLE">LLE</MenuItem>
                                                                            <MenuItem value="InterimStorageOperator">IS</MenuItem>
                                                                            <MenuItem value="Plant">Plant</MenuItem>
                                                                        </Select>
                                                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage.destinationStakeholderTypeError}</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} lg={4}>
                                                                    <FormControl fullWidth size="small" required error={errorMessage.destinationStakeholderUrnError}>
                                                                        <InputLabel>Destination Stakeholder URN</InputLabel>
                                                                        <Select label="Destination Stakeholder URN" value={destinationStakeholderUrn || ''} name="secondPartyUrn" onChange={(e) => onDestinationUrnChange(e)}>

                                                                            {destinationUrnList &&
                                                                                destinationUrnList?.map((items) => (
                                                                                    <MenuItem value={items.stakeholderUrn}>{items.stakeholderUrn}</MenuItem>

                                                                                ))}
                                                                        </Select>
                                                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage.destinationStakeholderUrnError}</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} lg={4}>
                                                                    <TextField
                                                                        label="Destination Stakeholder Name"
                                                                        value={destinationStakeholderDetails?.name || ''}
                                                                        fullWidth
                                                                        size="small"
                                                                        InputProps={{ readOnly: true }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12} lg={4} hidden={!(poStakeholderType === "HIT")}>
                                                                    <FormControl fullWidth size="small" required error={errorMessage.planningNumberError}>
                                                                        <InputLabel>Planning Number</InputLabel>
                                                                        <Select label="Planning Number" name="planningNumber" value={planningNumber || ''} onChange={(e) => onPlanningNumberChange(e)}>
                                                                            <MenuItem><em>Planning Number</em></MenuItem>
                                                                            {hitPlanningNumberList &&
                                                                                hitPlanningNumberList.map((items) => (
                                                                                    <MenuItem value={items.planningNumber}>{items.planningNumber}</MenuItem>

                                                                                ))}
                                                                        </Select>
                                                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage.planningNumberError}</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} lg={4}>
                                                                    <TextField fullWidth required size="small"
                                                                        error={errorMessage.totalShortCloseQtyError}
                                                                        helperText={errorMessage.totalShortCloseQtyError}
                                                                        type="number"
                                                                        onFocus={handleNumberFieldFocus}
                                                                        name="totalShortCloseQuantity"
                                                                        label="PO Quantity"
                                                                        value={shortCloseQty}
                                                                        onChange={(e) => onShortCloseQtyChange(e)}
                                                                        onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')' || evt.key === 'e') && evt.preventDefault()}
                                                                        inputProps={{
                                                                            maxLength: 10
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                {/* <Grid item xs={12} lg={4}>
                                                    <TextField fullWidth required size="small"
                                                        error={errorMessage.totalDistanceTravelledError}
                                                        helperText={errorMessage.totalDistanceTravelledError}
                                                        type="number"
                                                        name="totalDistanceTravelled"
                                                        label="Distance Travelled"
                                                        value={distanceTravelled}
                                                        onChange={(e) => onDistanceTravelledChange(e)}
                                                        onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')' || evt.key === 'e') && evt.preventDefault()}
                                                        inputProps={{
                                                            maxLength: 10
                                                        }}
                                                    />
                                                </Grid> */}
                                                            </>
                                                        }
                                                        {poStakeholderType === "HIT" && manualPoDetails?.serviceStakeholderType === "Transporter" && <Grid item xs={12} lg={4}>
                                                            <TextField fullWidth required size="small"
                                                                error={errorMessage.distanceTravelledError}
                                                                helperText={errorMessage.distanceTravelledError}
                                                                type="number"
                                                                onFocus={handleNumberFieldFocus}
                                                                name="distanceTravelled"
                                                                label="Distance Travelled(in KM)"
                                                                value={distanceTravelled || ''}
                                                                onChange={(e) => onDistanceTravelledChange(e)}
                                                                onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')' || evt.key === 'e') && evt.preventDefault()}
                                                            />
                                                        </Grid>}
                                                    </Grid>

                                                </Grid>
                                            }
                                            {
                                                (poStakeholderType === "Transporter" || poStakeholderType === "LLE" || poStakeholderType === "Plant" || poStakeholderType === "Interim Storage Operator") &&
                                                <Grid item xs={12}>
                                                    <Typography variant="subtitle1" sx={{ mb: 1, mt: 1 }}>Select {poStakeholderType} for {poType} Creation</Typography>
                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12} lg={4}>
                                                            <Autocomplete
                                                                value={urns.find(o => o.urn === searchTerm) || null}
                                                                getOptionLabel={(opt) => `${opt.urn} - ${opt.name}`}
                                                                isOptionEqualToValue={(opt, val) => opt.urn === val.urn}
                                                                onChange={(_, newValue) => {
                                                                    const urn = newValue?.urn ?? "";
                                                                    setSearchTerm(urn);
                                                                    handleSearch(newValue);
                                                                    setSelectedStakeholder(newValue);
                                                                    newValue && getUnrestrictedInventory(urn);
                                                                    getTaxData(urn);
                                                                    setDestinationStakeholderType('');
                                                                    setDestinationStakeholderUrn('');
                                                                    setDestinationUrnList([]);
                                                                    setSourceStakeholderType('');
                                                                    setSourceStakeholderUrn('');
                                                                    setSourceUrnList([]);
                                                                    // setGetTaxDetails('');
                                                                    // setInventoryLevel('');
                                                                    setErrorMessage({ ...errorMessage, searchUrnError: "" });
                                                                }}
                                                                options={urns || []} // Ensure options is an array, even if it's initially undefined
                                                                renderInput={(params) => (
                                                                    <TextField {...params} label="Search URN" variant="outlined" fullWidth size="small"
                                                                        required error={errorMessage.searchUrnError} helperText={errorMessage.searchUrnError} />
                                                                )}
                                                            />
                                                        </Grid>
                                                        {selectedStakeholder && (
                                                            <Grid item xs={12} lg={4}>
                                                                <TextField
                                                                    label="Stakeholder Name"
                                                                    value={getStakeholderDisplayName(selectedStakeholder)}
                                                                    fullWidth
                                                                    size="small"
                                                                    InputProps={{ readOnly: true }}
                                                                />
                                                            </Grid>
                                                        )}

                                                        <Grid item xs={12} lg={4} hidden={!(poStakeholderType === "LLE" || poStakeholderType === "Plant")}>
                                                            <TextField fullWidth size="small"
                                                                disabled
                                                                label="Inventory Level"
                                                                type="number"
                                                                value={searchTerm ? (poMaterialType === "rawbamboo" ? inventoryLevel.unrestrictedRBInventory : poMaterialType === "chipbamboo" ? inventoryLevel.unrestrictedCBInventory : '') : ''} />
                                                        </Grid>
                                                        <Grid item xs={12} lg={4} hidden={!(poStakeholderType === "LLE" || poStakeholderType === "Plant")}>
                                                            <TextField fullWidth size="small"
                                                                disabled
                                                                hidden={poMaterialType === "chipbamboo"}
                                                                label="Inventory Expected Chip Quantity"
                                                                value={poMaterialType === "rawbamboo" ? ExpectedChipQuantity : 0}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} lg={4}>
                                                            <TextField fullWidth required size="small"
                                                                error={errorMessage.poQuantityError}
                                                                helperText={errorMessage.poQuantityError}
                                                                type="number"
                                                                onFocus={handleNumberFieldFocus}
                                                                // name="poQuantity"
                                                                label="PO CB Quantity"
                                                                value={poQuantity || ''}
                                                                onChange={(e) => onPoQuantityChange(e)}
                                                                onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')' || evt.key === 'e') && evt.preventDefault()}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} lg={4} hidden={!(poType === "SCO")}>
                                                            <TextField fullWidth size="small"
                                                                type="number"
                                                                onFocus={handleNumberFieldFocus}
                                                                disabled
                                                                label="PO Expected RB Quantity"
                                                                value={(poQuantity * rbRbRation).toFixed(2)}
                                                            />
                                                        </Grid>
                                                        {poStakeholderType === "Transporter" &&
                                                            <>
                                                                <Grid item xs={12} lg={4}>
                                                                    <FormControl fullWidth size="small" required={errorMessage.sourceStakeholderTypeError}>
                                                                        <InputLabel>Source Stakeholder Type</InputLabel>
                                                                        <Select label="Source Stakeholder Type" name="sourceStakeholderType" value={sourceStakeholderType || ''} onChange={(e) => onSourceTypeChange(e)}>
                                                                            <MenuItem value="LLE">LLE</MenuItem>
                                                                            <MenuItem value="InterimStorageOperator">IS</MenuItem>
                                                                        </Select>
                                                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage.sourceStakeholderTypeError}</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} lg={4}>
                                                                    <FormControl fullWidth size="small" required error={errorMessage.sourceStakeholderUrnError}>
                                                                        <InputLabel>Source Stakeholder URN</InputLabel>
                                                                        <Select label="Source Stakeholder URN" value={sourceStakeholderUrn || ''} name="sourceStakeholderUrn" onChange={(e) => onSourceUrnChange(e)}>
                                                                            {sourceUrnList &&
                                                                                sourceUrnList?.map((items) => (
                                                                                    <MenuItem value={items.stakeholderUrn}>{items.stakeholderUrn}</MenuItem>
                                                                                ))}
                                                                        </Select>
                                                                        <FormHelperText sx={{ color: 'red' }}>{errorMessage.sourceStakeholderUrnError}</FormHelperText>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} lg={4}>

                                                                    <TextField
                                                                        label="Source Stakeholder Name"
                                                                        value={sourceStakeholderDetails?.name || ''}
                                                                        fullWidth
                                                                        size="small"
                                                                        InputProps={{ readOnly: true }}
                                                                    />

                                                                </Grid>
                                                            </>}
                                                        <Grid item xs={12} lg={4} hidden={((poStakeholderType === "LLE" || poStakeholderType === "Plant") && poType === "SCO")}>
                                                            <FormControl fullWidth size="small" required={errorMessage.destinationStakeholderTypeError}>
                                                                <InputLabel>Destination Stakeholder Type</InputLabel>
                                                                <Select label="Desination Stakeholder Type" name="secondPartyType" value={destinationStakeholderType || ''} onChange={(e) => onDestinationTypeChange(e)}>
                                                                    {(poStakeholderType === "Transporter" && poType === "SO") && <MenuItem value="LLE">LLE</MenuItem>}
                                                                    {!(poStakeholderType === "Transporter" && sourceStakeholderType === "InterimStorageOperator") && <MenuItem value="InterimStorageOperator">IS</MenuItem>}
                                                                    {!(poStakeholderType === "Transporter" && sourceStakeholderType === "Plant") && <MenuItem value="Plant">Plant</MenuItem>}
                                                                </Select>
                                                                <FormHelperText sx={{ color: 'red' }}>{errorMessage.destinationStakeholderTypeError}</FormHelperText>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={12} lg={4} hidden={((poStakeholderType === "LLE" || poStakeholderType === "Plant") && poType === "SCO")}>
                                                            <FormControl fullWidth size="small" required error={errorMessage.destinationStakeholderUrnError}>
                                                                <InputLabel>Destination Stakeholder URN</InputLabel>
                                                                <Select label="Destination Stakeholder URN" value={destinationStakeholderUrn || ''} name="secondPartyUrn" onChange={(e) => onDestinationUrnChange(e)}>
                                                                    {destinationUrnList &&
                                                                        destinationUrnList?.map((items) => (
                                                                            <MenuItem value={items.stakeholderUrn}>{items.stakeholderUrn}</MenuItem>
                                                                        ))}
                                                                </Select>
                                                                <FormHelperText sx={{ color: 'red' }}>{errorMessage.destinationStakeholderUrnError}</FormHelperText>
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid item xs={12} lg={4} hidden={((poStakeholderType === "LLE" || poStakeholderType === "Plant") && poType === "SCO")}>
                                                            <TextField
                                                                label="Destination Stakeholder Name"
                                                                value={destinationStakeholderDetails?.name || ''}
                                                                fullWidth
                                                                size="small"
                                                                InputProps={{ readOnly: true }}
                                                            />
                                                        </Grid>
                                                        {poStakeholderType === "Transporter" &&
                                                            <>
                                                                <Grid item xs={12} lg={4}>
                                                                    <TextField fullWidth required size="small"
                                                                        error={errorMessage.distanceTravelledError}
                                                                        helperText={errorMessage.distanceTravelledError}
                                                                        type="number"
                                                                        onFocus={handleNumberFieldFocus}
                                                                        name="distanceTravelled"
                                                                        label="Distance Travelled(in KM)"
                                                                        value={distanceTravelled || ''}
                                                                        onChange={(e) => onDistanceTravelledChange(e)}
                                                                        onKeyDown={(evt) => (evt.key === '_' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')' || evt.key === 'e') && evt.preventDefault()}
                                                                    />
                                                                </Grid></>}
                                                    </Grid>
                                                </Grid>
                                            }
                                            {
                                                poStakeholderType === "LLE" && poType === "SCO" &&
                                                <>
                                                    <Divider sx={{
                                                        width: '105%',
                                                        bgcolor: 'black',
                                                        marginTop: '3vh'
                                                    }} mt={2} />
                                                    <Grid item xs={12}>
                                                        <Typography variant="subtitle1" sx={{ mb: 1, mt: 1 }}>
                                                            Tax Details
                                                        </Typography>
                                                        <Grid container spacing={3}>
                                                            <Grid item xs={12} lg={4}>
                                                                <TextField fullWidth label="Tax Code" disabled value={getTaxDetails?.appKey || ''} />
                                                            </Grid>
                                                            <Grid item xs={12} lg={6}>
                                                                <TextField fullWidth label="Tax Details" disabled value={getTaxDetails?.value || ''} />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </>

                                            }

                                        </Grid>
                                    </CardContent>
                                </Card>
                                <Dialog maxWidth="xxl"
                                    open={open}
                                    onClose={handleClose}>
                                    <DialogTitle>PO Preview</DialogTitle>
                                    <DialogContent>
                                        <Container >
                                            <div class="logo-container"><img src="https://abrplscmsandbox.blob.core.windows.net/imageslatest/abepl-logo.png"
                                                alt="Company Logo" width="150" /></div>
                                            <div class="organization-details"> <strong>Assam Bio Ethanol Private Limited</strong><br /> (A JOINT VENTURE
                                                ENTERPRISE)<br /> POST BOX NO. 003, N.R.COMPLEX<br /> DISTRICT : GOLAGHAT(ASSAM)<br /> PIN : 785699 </div>
                                            {/* <div class="box-container1"> */}
                                            <div class="boxPrint1"> <strong>CIN:</strong> U74999AS2018PTC018547<br /> <strong>PAN: </strong>
                                                AAQCA9789H<br /> <strong>TAN:</strong> SHLA04440C <br /> <strong>GSTN:</strong> 18AAQCA9789H1ZP <br />
                                            </div>
                                            <div class="boxPrint">
                                                <div class="headerPrint">Purchase Order</div>
                                                <p class="sub-heading" style={{ margin: "0px" }}> PO Number: {previewDetails?.poNumber}</p>
                                                <p class="sub-heading" style={{ margin: "0px" }}> Date: <strong>{moment(date).format('DD/MM/YYYY')}</strong></p>
                                                <p class="sub-heading" style={{ margin: "0px" }}> Subject: <strong>{previewDetails?.poSubjectLine}</strong></p>
                                            </div>
                                            {/* </div> */}
                                            {/* <div class="box-container2"> */}
                                            <div>
                                                <h6 style={{ marginTop: "10px" }}><b>Vendor Details:</b></h6>
                                                <p class="sub-heading">Name: {previewDetails?.poStakeholderName}</p>
                                                <p class="sub-heading">URN: {previewDetails?.poStakeholderUrn}</p>
                                                <p class="sub-heading">Contact Person: {previewDetails?.poContactPerson}</p>
                                                <p class="sub-heading">Contact Number: {previewDetails?.poStakeholderContactNo}</p>
                                                <p class="sub-heading">Address: {previewDetails?.poStakeholderAddress}</p>
                                            </div>
                                            <div >
                                                <h6 style={{ marginTop: "15px" }}><b>Bill To:</b></h6>
                                                <p class="sub-heading">Name: {previewDetails?.customerName}</p>
                                                <p class="sub-heading">Address: {previewDetails?.customerAddress}</p>
                                                <p class="sub-heading">Contact Number: {previewDetails?.customerPhonNumber}</p>
                                            </div>
                                            {previewDetails?.poStakeholderType === "Transporter" && <div >
                                                <h6 style={{ marginTop: "15px" }}><b>Pick-up Details:</b></h6>
                                                <p class="sub-heading">Name: {previewDetails?.sourceStakeholderName}</p>
                                                <p class="sub-heading">Address: {previewDetails?.sourceStakeholderLocationAddress}</p>
                                                <p class="sub-heading">Contact Number: {previewDetails?.sourceStakeholderContactNo}</p>
                                            </div>}
                                            {previewDetails?.poStakeholderType != "LLE" && <div >
                                                <h6 style={{ marginTop: "15px" }}><b>Ship To:</b></h6>
                                                <p class="sub-heading">Name: {previewDetails?.destinationStakeholderName}</p>
                                                <p class="sub-heading">Address: {previewDetails?.destinationStakeholderAddress}</p>
                                                <p class="sub-heading">Contact Number: {previewDetails?.destinationStakeholderPhonNumber}</p>
                                            </div>}

                                            {/* </div> */}
                                            <div class="body-section">
                                                <table class="table-bordered" style={{ marginTop: "20px" }}>
                                                    <thead>
                                                        <tr>
                                                            <th class="table-header">Item Code</th>
                                                            <th class="table-header">Item Desc</th>
                                                            <th class="table-header">Quantity (MT)</th>
                                                            {(poStakeholderType === "Transporter" || poStakeholderType === "HIT" && manualPoDetails?.serviceStakeholderType === "Transporter") && <th class="table-header">Distance Travelled (KM)</th>}
                                                            <th class="table-header">Price (INR)</th>
                                                            <th class="table-header">Total (Exc. Taxes) (INR)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td class="table-row">{previewDetails?.itemCode}</td>
                                                            <td class="table-row">{previewDetails?.poMaterialType}</td>
                                                            <td class="table-row">{previewDetails?.poQuantity}</td>
                                                            {(poStakeholderType === "Transporter" || poStakeholderType === "HIT" && manualPoDetails?.serviceStakeholderType === "Transporter") && <td class="table-row">{distanceTravelled}</td>}
                                                            <td class="table-row">{previewDetails?.poUnitPrice}</td>
                                                            <td class="table-row">{previewDetails?.poAmount}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <hr />
                                            <table class="table-bordered" style={{ marginTop: "5px" }}>
                                                <thead>
                                                    <tr>
                                                        <th class="table-header">Total CGST</th>
                                                        <th class="table-header">Total SGST</th>
                                                        <th class="table-header">Total IGST</th>
                                                        <th class="table-header">Total Tax</th>
                                                        <th class="table-header">Total (Inc. Taxes) (INR)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td class="table-row">{previewDetails?.totalCGST}</td>
                                                        <td class="table-row">{previewDetails?.totalSGST}</td>
                                                        <td class="table-row">{previewDetails?.totalIGST}</td>
                                                        <td class="table-row">{previewDetails?.totalTax}</td>
                                                        <td class="table-row">{previewDetails?.totalAmount}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <hr />
                                            <table>
                                                <tr>
                                                    <td style={{ width: "20%" }}>Amount in words:</td>
                                                    <td style={{ width: "75%" }}>{previewDetails?.amountWords}</td>
                                                </tr>
                                            </table>
                                            <hr />
                                            <h5 style={{ marginTop: "20px" }}><b>For Assam Bio Ethanol Private Limited</b></h5>
                                            <div class="box-container1" style={{ marginTop: "100px" }}>
                                                <div class='boxPrint'>
                                                    <p class="sub-heading">Head Purchase</p>
                                                </div>
                                                <div class='boxPrint2'>
                                                    <p class="sub-heading2">Chief Executive Officer</p>
                                                </div>
                                            </div>
                                            {/* <div style={{ height: "25px" }}></div> */}
                                            <div class="terms">
                                                <h5><b>Terms & Conditions:</b></h5>
                                                <p style={{ whiteSpace: 'pre-wrap' }}>
                                                    {manualPoDetails?.poDescription}
                                                </p>

                                            </div>
                                            <div class="footer"> Registered Office: Assam Bio Ethanol Private Limited, G.S. Road, Christanbasti,<br />
                                                Guwahati- 781005 <br /> Website: www.abepl.co.in;<br /> Corporate Identification Number :
                                                U74999AS2018PTC018547 </div>
                                        </Container>

                                    </DialogContent>

                                </Dialog>

                                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }} hidden={!poStakeholderType}>
                                    {
                                        addedGrowerPo?.length === 0 ? null :
                                            <Button endIcon={<SubmitIcon />} variant="contained" hidden={!(poStakeholderType === "Grower")} onClick={(e) => onSubmit(e)}>
                                                Submit
                                            </Button>
                                    }

                                    {
                                        poStakeholderType === "Grower" ? null :
                                            <>
                                                <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" color="primary" onClick={() => getPoPreview()} startIcon={<PreviewIcon />}>Preview</Button>
                                                <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" hidden={poStakeholderType === "Plant"} onClick={(e) => onHitSubmit(e)} endIcon={<SubmitIcon />}>Submit</Button>
                                                <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" hidden={poStakeholderType !== "Plant"} onClick={(e) => onPlantSubmit(e)} endIcon={<SubmitIcon />}>Submit</Button>
                                            </>
                                    }
                                </Box>

                            </>
                }
            </Container>
            <ConfirmationPopover onOpen={logModalOpen} onConfirm={onConfirmSubmit} onClose={handleLogModalClose} action="Submit" />
            <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmHitSubmit} onClose={handleConfirmClose2} action="Submit" />
            <ConfirmationPopover onOpen={confirmOpen3} onConfirm={onConfirmPlantSubmit} onClose={handleConfirmClose3} action="Submit" />

        </>
    )
}